(ns iris.posts.events
  (:require
   [re-frame.core :as re-frame]
   [iris.events :as events]
   [iris.utils :as utils]
   [iris.hench :as hench]
   [cljs.core.async :refer [go go-loop <! chan take!]]
   [cljs.core.async.interop :refer-macros [<p!]]
   [iris.firebase :as fb]
   [iris.indexeddb :as idb]
   [iris.localstorage :as localstorage]
   [day8.re-frame.async-flow-fx :as async-flow-fx]
   [iris.data.api :as data-api]
   [iris.routes :as routes]
   [clojure.string :as string]
  ;;  [iris.posts.views.thread-alert :refer [get-thread-alerts]]
   [iris.globals :as globals]

   [iris.posts.common :refer [ruid-to-ahref
                              linkify-header
                              REF_HTAG_RE
                              REF_FREF_RE
                              REF_PREF_RE
                              OLD_REF_PREF_RE_STR
                              OLDER_REF_PREF_RE_STR]]

   [iris.error.events :as error-events]

   [iris.sessionstorage :as sessionstorage]

   [iris.worker-pool :as worker-pool]
   ))


;; we do start and stop interval on post load so not sure if checking batch-datetime is necessary
;; but perhaps it is a better method since it doesn't involve starting and stopping interval??
;; NOTE: 04/22/2024 interval is still in use through http get post list. Decided not to take it out at this point
;; run-interval-code with :posts :batch-datetime is therefore not needed (because each post load offsets the execution of interval code)
;; but it could be useful to setup things on a more granular level - perhaps some tasks could be run more earlier/later/more/less frequent
;; based on batch-datetime
;; NOTE: DO NOT DELETE THIS FUNCTION
;; (re-frame/reg-event-fx
;;  ::run-interval-code
;;  (fn [{:keys [db]} [_]]
;;    (println "entering ::run-interval-code")
;;    (let [batch-datetime (get-in db [:posts :batch-datetime])
;;          now-datetime (.now js/Date)]
;;      (println "run-interval-code :: " batch-datetime now-datetime)
;;      (if (> (/ (- now-datetime batch-datetime) 1000) 120)
;;        (do
;;          (println "::run-interval-code :: more than 120 seconds expired since last batch, do set-post-fb-data")
;;          (re-frame/dispatch [::set-timer (.now js/Date)])
;;          (re-frame/dispatch [::set-post-fb-data]))
;;        (println "::run-interval-code :: skipping, not enough time has passed"))
;;      {})))



;; Scheduled code
(def interval-id (atom nil))

(defn interval-code []
  (println "INTERVAL CODE STARTING" (.-visibilityState js/document))
  ;; TODO: set-timer should be set every time the posts are loaded - and
  ;; before running the interval code check that x minutes have passed - currently
  ;; there is too much traffic jam on workers - it's too congested
  ;; with tasks due to interval code + thread alerts running all the time
  ;; another option is not to run the code, or run it less frequently, in case of mobile or if device has < n cores
  ;; yet another option is to call each worker and tell it to stop working, kinda like interval stop
  (when (= (.-visibilityState js/document) "visible")
    (println "INTERVAL will run code")
    (re-frame/dispatch [::set-timer (.now js/Date)])
    (re-frame/dispatch [::set-post-fb-data]))
  ;; (re-frame/dispatch [::admin-all-moderation-logs nil])
  ;; (re-frame/dispatch [::run-interval-code])
  )

(defn interval-start []
  (when (nil? @interval-id)
    (println "STARTING INTERVAL")
    (reset! interval-id (js/setInterval interval-code 60000))))

(defn interval-end []
  (when (some? @interval-id)
    (println "STOPPING INTERVAL")
    (js/clearInterval @interval-id)
    (reset! interval-id nil)))
;; Scheduled code - end

(add-watch globals/fb-user :fb-user-interval
           (fn [key atom old-state new-state]
             (when (and (nil? new-state)
                        (not (nil? @interval-id)))
               (println "TURNING OFF INTERVAL CODE BECAUSE OF FB_USER")
               (interval-end))))


(defn encode-post-actions-state [status qc hidden locked]
  (cond-> ""
    (or (= status "P")
        (= status "R")
        (= status "Q")
        (= status "S")
        (= status "T")) (str status)
    (true? qc) (str "q")
    (true? hidden) (str "h")
    (true? locked) (str "l")))

(defn decode-post-actions-state [state]
  (when (and (string? state) (not-empty state))
    (let [s (set state)]
      (cond-> {:qc (contains? s "q")
               :isHidden (contains? s "h")
               :isLocked (contains? s "l")}
        (contains? s "P") (assoc :status "P")
        (contains? s "R") (assoc :status "R")
        (contains? s "Q") (assoc :status "Q")
        (contains? s "S") (assoc :status "S")
        (contains? s "T") (assoc :status "T")))))


;; TODO: http complete is repeated in each section
;; TODO: in events it's called "set-loading"
(re-frame/reg-event-db
 ::http-complete
 (fn [db [_ data]]
   (assoc db :loading false)))

(re-frame/reg-event-db
 ::http-loading
 (fn [db [_ value]]
   (assoc db :loading value)))


(re-frame/reg-event-db
 ::set-timer
 (fn [db [_ data]]
   (assoc-in db [:posts :timer] data)))


(re-frame/reg-event-db
 ::set-font-size
 (fn [db [_ data]]
   (assoc-in db [:posts :font-size] (int data))))

(re-frame/reg-event-db
 ::inc-font-size
 (fn [db [_]]
   ;;  TODO: this is impure function with side effects, fix it

  ;;  (localstorage/set-item! "iris.post.font-size" (+ (get-in db [:posts :font-size]) 10))
  ;;  (assoc-in db [:posts :font-size] (+ (get-in db [:posts :font-size]) 10))

   (let [font-size (get-in db [:posts :font-size])]
     (when (< font-size 300)
       (localstorage/set-item! "iris.post.font-size" (+ font-size 10))
       (assoc-in db [:posts :font-size] (+ font-size 10))))))

(re-frame/reg-event-db
 ::dec-font-size
 (fn [db [_]]
   ;;  TODO: this is impure function with side effects, fix it
  ;;  (localstorage/set-item! "iris.post.font-size" (- (get-in db [:posts :font-size]) 10))
  ;;  (assoc-in db [:posts :font-size] (- (get-in db [:posts :font-size]) 10))

   (let [font-size (get-in db [:posts :font-size])]
     (when (> font-size 0)
       (localstorage/set-item! "iris.post.font-size" (- font-size 10))
       (assoc-in db [:posts :font-size] (- font-size 10))))))

;; TODO: set-post-ref-preview is no longer in use, consider deleting (replaced by set-post-ref-preview-data)
(re-frame/reg-event-db
 ::set-post-ref-preview
 (fn [db [_ data]]
   (assoc-in db [:posts :ref-preview] data)))

(re-frame/reg-event-db
 ::set-post-ref-preview-data
 (fn [db [_ paruid ruid data]]
   (assoc-in db [:posts :ref-preview-data (keyword paruid) (keyword ruid)] data)))

(re-frame/reg-event-db
 ::unset-post-ref-preview-data
 (fn [db [_ paruid ruid]]
   (update-in db [:posts :ref-preview-data (keyword paruid)] dissoc (keyword ruid))))




;; (re-frame/reg-event-db
;;  ::set-thread-follow
;;  (fn [db [_ data]]
;;    (assoc-in db [:posts :thread-follow] data)))


;; Calling RPC at URL: https://dev.apollo.ipad.org/rpc
;; JSON payload:
;;  {
;;     "method": "Post.List",
;;     "params": {
;;         "data": {
;;             "scopes": [],
;;             "level": 0,
;;             "status": "*",
;;             "after": "",
;;             "before": "",
;;             "bookmark": "",
;;             "page": 1,
;;             "limit": 10,
;;             "ruids_only": false
;;         },
;;         "options": {
;;             "debug": false
;;         }
;;     },
;;     "id": 0,
;;     "jsonrpc": "2.0"
;; }

;; (defn get-distinct-scopes [result-data]
;;   (loop [v []
;;          d result-data]
;;     (if-not (empty? d)
;;       (recur (into v (:scopes (first d))) (rest d))
;;       (filter raidizable? (distinct v)))))


(defn get-distinct-eids [result-data]
  ;; (println "get-distinct-eids::" result-data)
  (distinct
   (loop [v []
          d result-data]
     (if-not (empty? d)
       (let [eid (:eid (:author (first d)))
             eid-vals (filterv some? (vals eid))]
         (recur (into v eid-vals) (rest d)))
       v))))


(defn raidize-post-author-eid [author-eid]
  (go-loop [eid-keys (keys author-eid)
            raids {}]
    (if (> (count eid-keys) 0)
      (let [k (first eid-keys)
            v (k author-eid)
            raid (if (some? v) (<p! (idb/get-raid v)) nil)
            new-raids (if (some? raid) (conj {k raid} raids) raids)
            rest-eid-keys (rest eid-keys)]
        (recur rest-eid-keys new-raids))
      raids)))


(re-frame/reg-event-db
 ::set-posts-meta
 (fn [db [_ data]]
   (assoc-in db [:posts :meta] data)))

(re-frame/reg-event-db
 ::set-posts-data
 (fn [db [_ data]]
  ;;  (println (map :id (get-in db [:posts :data])))
  ;;  (println (map :id data))
  ;;  checks to make sure data we are updating is the same
  ;;  TODO: perhaps sorting should happen prior to comparison
  ;;  even better ::set-post-fb-data should be stopped
  ;;  furthermore, set-post-list-data should have similar mechanism for validation
  ;;  again, even better, should be stopped
  ;;  (if (= (map :id (get-in db [:posts :data]))
  ;;         (map :id data))
  ;;    (assoc-in db [:posts :data] data)
  ;;    db)

   (assoc-in db [:posts :data] data)
   ))

(re-frame/reg-event-db
 ::set-fb-data
 (fn [db [_ k data]]
  ;;  (assoc-in db [:posts :fb-data k] data)
   (update-in db [:posts :fb-data k] merge data)
   ))

;; (re-frame/reg-event-db
;;  ::set-fb-data-row
;;  (fn [db [_ k id data]]
;;    (assoc-in db [:posts :fb-data k id] data)))

(re-frame/reg-event-db
 ::set-fb-data-row
 (fn [db [_ k id data]]
   (assoc-in db [:posts :fb-data k id] data)))

(re-frame/reg-event-db
 ::set-posts-data-row-prop
 (fn [db [_ index k value]]
   (assoc-in db [:posts :data index k] value)))

;; NOTE: we have "::update-post-props" event already
(re-frame/reg-event-db
 ::update-posts-data-row
 (fn [db [_ ruid data]]
   (assoc-in db [:posts :data] (mapv #(if (= ruid (:ruid %)) data %) (get-in db [:posts :data])))))


;; (re-frame/reg-event-db
;;  ::set-post-fb-data
;;  (fn [db [_]]


(defn on-update-fb-data-replies [thread data]
  (re-frame/dispatch [::set-fb-data-row :replies (str "@OP" thread) data]))

(defn on-update-fb-data-votes [nick thread data]
  (println "on-update-fb-data-votes::" nick thread data (keyword (str nick thread)))
  (re-frame/dispatch [::set-fb-data-row :votes
                      ;; (str nick thread)
                      (keyword (str nick thread))
                      data]))


;; (re-frame/reg-event-fx
;;  ::set-post-fb-data
;;  (fn [{:keys [db]} [_]]
;;    ;;  TODO: check interval-id, if same recur, otherwise not
;;   ;;  (println "::set-post-fb-data here")
;;    (let [starting-interval-id @interval-id]
;;      (go-loop [data (get-in db [:posts :data])
;;                fb-data []
;;                experiment-data {}]
;;        (cond (= starting-interval-id @interval-id)
;;              (let [d (first data)
;;                    r (rest data)
;;                    ws (:ws d)
;;                    forum (subs (:forum d) 1 (.indexOf (:forum d) "."))
;;                    thread (:thread d)
;;                    nick (subs (:id d) 0 (.indexOf (:id d) "+"))
;;                   ;;  votes (<p! (fb/get-post-votes ws forum thread nick))
;;                    new-fb-data []
;;                    new-experiment-data {}]
;;                (fb/get-post-votes ws forum thread nick on-update-fb-data-votes)
;;                (when (= nick "@OP")
;;                  (fb/get-replies ws thread on-update-fb-data-replies))
;;                (when (not-empty r)
;;                  (recur r new-fb-data new-experiment-data))
;;                )
;;              :else
;;              (println "Starting interval id no longer the same" starting-interval-id @interval-id))))
;;   ;;  db
;;    {}))




(defn select-posts-fb-data-keys [posts-data]
  (loop [data posts-data
         select-posts-data []]
    (let [d (first data)
          r (rest data)
          s (select-keys d [:ws :forum :thread :level :id])]
      (if (not-empty r)
        (recur r (conj select-posts-data s))
        (conj select-posts-data s)))))


(defn set-fb-data-votes [posts-votes-data]
  (re-frame/dispatch [::set-fb-data :votes (:result posts-votes-data)]))

(defn set-fb-data-replies [posts-replies-data]
  (re-frame/dispatch [::set-fb-data :replies (:result posts-replies-data)]))

(defn set-fb-data-logs [result-data]
  (when-let [logs (not-empty (get-in result-data [:result :logs]))]
    (re-frame/dispatch [::set-admin-all-moderation-logs-2 logs]))
  (when-let [updates (not-empty (get-in result-data [:result :updates]))]
    (doseq [[k v] updates]
      (re-frame/dispatch [::update-post-props (name k) v]))))


(re-frame/reg-event-fx
 ::set-post-fb-data
 (fn [{:keys [db]} [_ result-data]]
   (let [posts-data (or result-data (get-in db [:posts :data]))]

     (loop [data (partition-all 5 (select-posts-fb-data-keys posts-data))]
       (let [d (first data)]

         (take! (worker-pool/do! {:handler :get-posts-votes, :arguments {:data d}}) set-fb-data-votes)
         (take! (worker-pool/do! {:handler :get-posts-replies, :arguments {:data d}}) set-fb-data-replies)
         (take! (worker-pool/do! {:handler :get-admin-all-moderation-logs :arguments {:data d :batch-datetime (get-in db [:posts :batch-datetime])}}) set-fb-data-logs))

         (when-let [r (not-empty (rest data))]
           (recur r))))
   {}))


(defn set-fb-data-eid-raid [raidized-eids]
  (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-eids [:result])]))

(re-frame/reg-event-fx
 ::set-post-fb-data-eid-raid
 (fn [{:keys [db]} [_ result-data]]
   ;; distinct eids partitions (deps). 16 eids in each partition.
   (loop [deps (partition-all 16 (get-distinct-eids result-data))]
     (let [dep (first deps)]

       (take! (worker-pool/do! {:handler :raidize-eids, :arguments {:data dep}}) set-fb-data-eid-raid)

       (when-let [r (not-empty (rest deps))]
         (recur r))))
   {}))


;; this function receives individual posts and their moderator logs from fb,
;; sorts them, determines which ones are new (came after the currently displayed post batch list)
;; and updates their local posts state data
;; decode-post-actions-state
;; NOTE: moved to worker!
(defn post-logs-update [d logs batch-datetime]
  (when (> (count logs) 0)
    ;; filter out fresh logs sorted in ascending order and reduce to a flat map containing updates
    (let [logs-asc (sort-by
                    ;; :datetime
                    :ms
                    logs)
          ;; logs-last (last logs-asc)
          logs-new (filter #(>
                            ;;  (:datetime %)
                             (:ms %)
                             batch-datetime) logs-asc)
          ;; logs-new-last (last logs-new)

          ;; {:qc false,
          ;; :uid nedim,
          ;; :state1 Phlq,
          ;; :dt 2023-09-22T14:42:46Z,
          ;; :ruid @OP+1oIm8ENR,
          ;; :state0 Rhlq,
          ;; :isLocked false,
          ;; :isHidden false,
          ;; :action APPROVE,
          ;; :ms 1695393766039}
          ;; we only need :ruid :qc :isLocked :isHidden :ruid and to flatten it
          ;; since we have all the fields, maybe there is no need to check on each field,
          ;; just reduce it to the latest values for each field
          ;; in fact, since each log contains complete state inshort form, maybe we can just use last (new) log's state instead of flattening it
          ;; logs-new-state-decoded (map (fn [item]
          ;;                               (println "(:state item):" (:state item))
          ;;                               (conj item (decode-post-actions-state (:state item)))) logs-new)
          ;; logs-new-last-decoded (merge logs-new-last (decode-post-actions-state logs-new-last) )

          ;; logs-flat (reduce (fn [res item]
          ;;                     (cond-> res
          ;;                       (contains? item :status) (assoc :status (:status item))
          ;;                       (contains? item :replying_disabled) (assoc :replying_disabled (:replying_disabled item))
          ;;                       (contains? item :hidden) (assoc :hidden (:hidden item))))
          ;;                   {}
          ;;                   logs-new)
          ;; updates (cond-> {}
          ;;           (and (contains? logs-flat :status) (or (not= (:status logs-flat) (:status d)) (and (= (:status logs-flat) (:status d)) (= (:qc d) false)))) (assoc :status (:status logs-flat))
          ;;           (and (contains? logs-flat :replying_disabled) (not= (:replying_disabled logs-flat) (:replying_disabled d))) (assoc :replying_disabled (:replying_disabled logs-flat))
          ;;           (and (contains? logs-flat :hidden) (not= (:hidden logs-flat) (:hidden d))) (assoc :hidden (:hidden logs-flat)))
          ]


      (when-not (empty? logs-new)
        (let [logs-new-last (last logs-new)
              logs-new-last-decoded (decode-post-actions-state (:state1 logs-new-last))
              updates (conj logs-new-last-decoded {:qc_by (:uid logs-new-last)})]
          (re-frame/dispatch [::update-post-props (:id d) updates]))

        ;; (when-not (empty? updates)
        ;;   (re-frame/dispatch [::update-post-props (:id d) (conj updates {:qc true :qc_by (:uid logs-last)})]))
        )
      ;; (println "logs-new-last-decoded:" logs-new-last-decoded logs-new)
      ;; perhaps need to add qc_by, based on who did last log (or first??)
      ;; (when-not (empty? updates)
      ;;   (re-frame/dispatch [::update-post-props (:id d) (conj updates {:qc true :qc_by (:uid logs-last)})]))
      )))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; Periodically takes data from [:posts :data] based on interval
;; OR uses fresh data from Post.List rpc call provided through args
;; and gets all logs moderation data from firebase for those post ids
;; finally, passed new log data based on [:posts :batch-datetime] to a function
;; that updates in real time [:posts :data] with any changes that might have occured
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; NOTE: moved to worker!
(re-frame/reg-event-fx
 ::admin-all-moderation-logs
 (fn [{:keys [db]} [_ dd]]


;; (take! (worker-pool/do! {:handler :get-admin-all-moderation-logs, :arguments {:data dd}})
;;        (fn [logs]
;;          (println "logs from worker:" (:result logs))
;;         (re-frame/dispatch [::set-admin-all-moderation-logs-2 (:result logs)])
;;          ))


  ;;  (let [starting-interval-id @interval-id]
  ;;    (when-let [posts-data (or dd (get-in db [:posts :data]))]
  ;;      (go-loop [data posts-data]
  ;;        (cond (= starting-interval-id @interval-id)
  ;;              (let [d (first data)
  ;;                    r (rest data)
  ;;                    logs (<p! (fb/<p-get-admin-all-moderation-logs (:ws db) (:id d)))]
  ;;                (println "admin all logs::" (vec (vals logs)))
  ;;                (when-not (empty? logs)
  ;;                  (re-frame/dispatch [::set-admin-all-moderation-logs (:id d) (vec (vals logs))])
  ;;                  (post-logs-update d (vec (vals logs)) (get-in db [:posts :batch-datetime])))
  ;;                (when-not (empty? r)
  ;;                  (recur r)))
  ;;              :else
  ;;              (println "Starting interval id no longer the same" starting-interval-id @interval-id)))))
   {}))


(defn set-fb-data-personal-logs [result-data]
  (re-frame/dispatch [::set-admin-moderation-logs (get-in result-data [:result :logs])]))

(re-frame/reg-event-fx
 ::personal-moderation-logs
 (fn [{:keys [db]} [_ ws]]

  ;;  NOTE: moved to worker, "get-admin-personal-moderation-logs" handler
  ;;  (go
  ;;    (let [logs (<p! (fb/<p-get-admin-moderation-logs ws))]
  ;;     ;;  (println "personal logs:" (vals logs))
  ;;      (re-frame/dispatch [::set-admin-moderation-logs (vec (vals logs))])
  ;;      ))

  ;; perhaps "uid" should be passed in?
   (take! (worker-pool/do! {:handler :get-admin-personal-moderation-logs, :arguments {:ws ws :uid (:uid @globals/fbjwt-payload)}}) set-fb-data-personal-logs)
   {})
 )

;; (re-frame/reg-event-db
;;  ::set-post-list-data
;;  (fn [db [_ data]]
;;    (let [result-data (get-in data [:result :data])
;;          result-meta (get-in data [:result :meta])]
;;      (-> db
;;          (assoc-in [:posts :data] result-data)
;;          (assoc-in [:posts :meta] result-meta)))))
(re-frame/reg-event-db
 ::set-post-list-data
 (fn [db [_ data]]
  ;;  (println "setting post list data::" data)
   (re-frame/dispatch [::fetch-nviews data])
   (assoc-in db [:posts :data] data)))

(re-frame/reg-event-fx
 ::fetch-nviews
 (fn [_ [_ posts-data]]
   ;; Only fetch nviews for OPs (level 1) - use :thread field (e.g. "+1jgf2k5s5") as Redis key
   (let [ruids (mapv :thread (filter #(= 1 (:level %)) posts-data))]
     (js/console.log "::fetch-nviews ruids:" (clj->js ruids))
     (when (seq ruids)
       (-> (data-api/get-nviews ruids)
           (.then (fn [result]
                    (js/console.log "::fetch-nviews result:" (clj->js result))
                    (re-frame/dispatch [::set-nviews result])))))
     {})))

(re-frame/reg-event-db
 ::set-nviews
 (fn [db [_ nviews-map]]
   (js/console.log "::set-nviews nviews-map:" (clj->js nviews-map))
   ;; nviews-map keys are thread values e.g. {"+1abc" {:nviews "96"} ...}
   ;; Only update OPs (level 1), match by :thread field
   (update-in db [:posts :data]
              (fn [posts]
                (mapv (fn [post]
                        (if (and (= 1 (:level post))
                                 (get nviews-map (:thread post)))
                          (assoc-in post [:counts :views] (get-in nviews-map [(:thread post) :nviews] 0))
                          post))
                      posts)))))



;; (re-frame/reg-event-fx
;;  ::set-post-list-meta
;;  (fn [{:keys [db]} [_ data]]
;;   ;;  {:db (assoc-in db [:posts :meta] data)}
;;    {:db (assoc-in db [:posts :meta] (merge data (get-in db [:posts :meta])))}
;;    ))

(re-frame/reg-event-fx
 ::set-post-list-meta
 (fn [{:keys [db]} [_ data]]
  ;;  {:db (assoc-in db [:posts :meta] data)}
  ;;  {:db (assoc-in db [:posts :meta] data)}
   {:db (-> db
            (assoc-in [:posts :meta] (dissoc data :screening_status))
            (update-in [:posts :screening-status] merge (get-in data [:screening_status])))}))


;; TODO: check if assoc-in meta screening status data should be merged - I'm afraid it's getting replaced here with each batch
(re-frame/reg-event-fx
 ::set-post-list-batch-meta
 (fn [{:keys [db]} [_ data]]
  ;;  {:db (assoc-in db [:posts :meta] data)}
  ;;  {:db (assoc-in db [:posts :batch-meta] data)}
  ;;  remove screening_status from batch-meta because we don't need it - moving it to :posts :screening-status, including the ones from PostList and PostBatchList
   {:db (-> db
            (assoc-in [:posts :batch-meta] (dissoc data :screening_status))
            ;; (assoc-in [:posts :screening-status] (get-in data [:screening_status])) ;; problem from TODO
            (update-in [:posts :screening-status] merge (get-in data [:screening_status]))

            )}))

(re-frame/reg-event-db
 ::set-post-list-batch-datetime
 (fn [db [_ datetime]]
   (assoc-in db [:posts :batch-datetime] datetime)))



;;  (re-frame/reg-event-db
  ;; ::http-get-post-list-success
  ;; (fn [db [_ data]]

(defn raidize-result-data
  ([data]
   (raidize-result-data data false))
  ([data skip-interval-id-check]


;; (let [worker-pool (worker-main/create-pool 2 js/webWorkerFile)
;;       print-result (fn [result-chan]
;;                      (go
;;                        (let [result (<! result-chan)]
;;                          (.debug js/console (str "MAIN>WORK::" result))
;;                          result)))]

;;   (print-result (worker-main/do-with-pool! worker-pool {:handler :mirror, :arguments {:a "Hallo" :b "Welt" :c 10}}))
;;   (print-result (worker-main/do-with-pool! worker-pool {:handler :mirror, :arguments {:a "Hallo" :b "Welt" :c 10 :d (js/ArrayBuffer. 10) :transfer [:d]} :transfer [:d]}))
;;   (print-result (worker-main/do-with-pool! worker-pool {:handler :test-fb, :arguments {:eid "c:edehwodbttqtywo7dyrdsyazkhulaes662o5pakncfjcllxoaom6r3mry6yklfqks7beh5w2yfy63"}}))
;;   (print-result (worker-main/do-with-pool! worker-pool {:handler :raidize, :arguments {:data data}})))

  ;;  (worker-pool/do! {:handler :mirror, :arguments {:a "Hallo" :b "Welt" :c 11}})
  ;;  (worker-pool/do! {:handler :mirror, :arguments {:a "Hallo" :b "Welt" :c 11 :d (js/ArrayBuffer. 10) :transfer [:d]} :transfer [:d]})
  ;;  (worker-pool/do-print-result! {:handler :test-fb, :arguments {:eid "c:edehwodbttqtywo7dyrdsyazkhulaes662o5pakncfjcllxoaom6r3mry6yklfqks7beh5w2yfy63"}})
  ;;  (worker-pool/do-print-result! {:handler :raidize, :arguments {:data data}})




  ;;  (when-let [result-data (not-empty data)]
  ;;   ;; (println "raidize-result-data" data)
  ;;    (println "@interval-id::" @interval-id)
  ;;    (let [eids (get-distinct-eids result-data)
  ;;          eids-count (count eids)
  ;;          c (chan)
  ;;          starting-interval-id @interval-id]
  ;;     ;; (println "eids collected:" eids)
  ;;      (when (not-empty eids)
  ;;        (println "NOT EMPTY EIDS")
  ;;        (hench/eid-to-raid-set-cache eids c)
  ;;        (go-loop [l eids-count]
  ;;          (cond (or (= starting-interval-id @interval-id) skip-interval-id-check)
  ;;                (do
  ;;                  (let [eid-raid (<! c)
  ;;                        eid (:eid eid-raid)
  ;;                        raid (:raid eid-raid)]
  ;;                    (idb/add-raid eid raid))
  ;;                  (if (> l 1)
  ;;                    (recur (dec l))
  ;;                    (loop [result-data data
  ;;                           raidized-data []
  ;;                           experiment-data {}]
  ;;                      (let [d (first result-data)
  ;;                            rest-data (rest result-data)
  ;;                            new-raidized-data []
  ;;                           ;; new-raidized-data (conj raidized-data
  ;;                           ;;                         (assoc-in d [:author :raid]
  ;;                           ;;                                   (<! (raidize-post-author-eid (:eid (:author d))))))

  ;;                            new-experiment-data (-> experiment-data
  ;;                                                    (assoc-in [:raid (:id d)] (<! (raidize-post-author-eid (:eid (:author d))))))]
  ;;                        (if (not-empty rest-data)
  ;;                          (recur rest-data new-raidized-data new-experiment-data)
  ;;                          (do
  ;;                           ;; (let [new-data (assoc-in data [:result :data] new-raidized-data)]
  ;;                           ;; new-data)
  ;;                           (println  "new-experiment-data" new-experiment-data)
  ;;                            new-experiment-data))))))
  ;;                :else
  ;;                (println "Interval id changed: " starting-interval-id @interval-id))))))

  ;;  (worker-pool/do! {:handler :raidize, :arguments {:data data}})



   (when-let [result-data (not-empty data)]
     (let [eids (get-distinct-eids result-data)]
       (worker-pool/do! {:handler :raidize-eids, :arguments {:data eids}})))

  ;;  (when-let [result-data (not-empty data)]
  ;;    (let [eids (get-distinct-eids result-data)]

  ;;      (loop [data eids]
  ;;        (let [d (first data)]

  ;;          (worker-pool/do! {:handler :raidize-eids, :arguments {:data d}})

  ;;          (when-let [r (not-empty (rest data))]
  ;;            (recur r))))

  ;;        ;;  (worker-pool/do! {:handler :raidize-eids, :arguments {:data eids}})
  ;;      ))



   ))



;; (re-frame/reg-event-fx
;;  ::http-get-post-list-success
;;  (fn [{:keys [db]} [_ predata data]]

;;    (let [all-data (if (nil? predata)
;;                     data
;;                     (assoc-in data [:result :data]
;;                               (merge (get-in data [:result :data])
;;                                      (get-in predata [:result :data]))))]

;;      (re-frame/dispatch [::set-post-list-data all-data])
;;      (re-frame/dispatch [::http-complete])

;;      (when (not-empty (get-in all-data [:result :data]))
;;        (interval-start)
;;       ;;  TODO: perhaps only "data" should be raidized, if "predata" is already raidized?
;;       ;; in case of thread OP it won't be, but in case of bookmark it will be
;;       ;; need some kind of flag to know whether to raidize predata or not

;;        (re-frame/dispatch [::set-post-fb-data]) ;;this used to wait raidized-result-data but i think it doesn't need to anymore since fb-data
;;        (println "ALL-DATA::" all-data)
;;        (take! (raidize-result-data all-data)
;;               (fn [raidized-result-data]
;;                 ;; (re-frame/dispatch [::set-post-list-data raidized-result-data])
;;                 ;; (re-frame/dispatch [::set-post-fb-data])
;;                 ;; (println "raidized-result-data::" raidized-result-data)
;;                 (re-frame/dispatch [::set-fb-data :raid (:raid raidized-result-data)])
;;                 ))))
;;    {}))


;;  TODO: do this with separate methods, list-success and list-batch-success (cleaner)

;;  Something to think about: If the rewrite happens on click, we'll save some regex execution time.
;;  If someone tries to open a post in a new tab, we can redirect them on backend to the new url.
;;  Redirects were handled on server in Castor but we don't do that in Iris because we would lose state/reload the app.
;;  Therefore rewriting on client is the best option, but if someone opens a post in a new tab, they lose state/reload the app anyway.

 (defn add-ws-to-refs-in-data [r v ws]
   (assoc-in r v
             (-> (get-in r v)
                 (string/replace REF_HTAG_RE (str "<a href=\"/h/$1." ws "\" class=\"ref htag\">"))
                 (string/replace REF_FREF_RE (str "<a href=\"$1." ws "\" class=\"ref fref\">"))
                ;;  TODO: this line may or may not belong here...this functions deals with adding ws to refs...but this line rewrites /p/ form into /t/ form...nothing to do with ws
                ;;  TODO: check on this - perhaps it should be {2,5} for ids like @1ekgs+1lqhcgbo
                ;;  10/31/23 switched to {2,5} because it wasn't working for ids such as /p/@dNtcb+16zEvLP3
                 ;;  12/16/24 switched thread part from {8} to {6,9} so we can match @OP+LqB3kJG. Furthermore, oldest posts might be as short as 6 and in the future we might go up to 9 and change format to lowercase base32
                 (string/replace REF_PREF_RE "<a href=\"/t/$2#$1\" class=\"ref pref\">")
                ;;  12/20/24 rewrite old post id formats, such as: <a href="/r/IWBcD1D">@IWBcD1D</a> and <a href="/r/RbaNjYE-1pdg">@RbaNjYE-1pdg</a>
                 (string/replace OLD_REF_PREF_RE_STR "<a href=\"/t/$1#$2\" class=\"ref pref\">")
                 (string/replace OLDER_REF_PREF_RE_STR "<a href=\"/t/$1#OP\" class=\"ref pref\">"))))

;;  TODO: perhaps this function should be renamed to something like "process-tags-and-refs" because of /p/ to /t/ rewrite in add-ws-to-refs-in-data above (nothing to do with ws)
 (defn add-ws-to-refs [data ws]
   (mapv
    #(if (or (> (get-in % [:counts :tags]) 0) (> (get-in % [:counts :refs]) 0))
       (cond (= (:level %) 1)
             (-> %
                 (add-ws-to-refs-in-data [:content :body] ws)
                 (add-ws-to-refs-in-data [:content :title] ws))
             (= (:level %) 2)
             (-> %
                 (add-ws-to-refs-in-data [:content :body] ws)))
       %)
    data))

 (re-frame/reg-event-fx
  ::http-get-post-list-success
  [(events/api-msg-interceptor {:mute-keys #{:result}})]
  (fn [{:keys [db]} [_ query-params predata curr-interval-id data]]

    ;; (println "PREDATAAAA::" predata)
    ;; (println "_::" _)

    (let [sdd (get-in db [:posts :data])
          bmd (get-in db [:posts :batch-meta])
          md (get-in data [:result :meta])
          ;; dd (get-in data [:result :data])
          dd (add-ws-to-refs (get-in data [:result :data]) (:ws query-params))
          ;; pd (if (empty? predata) predata (if (vector? predata) predata (conj [] predata)))
          ;; pd (if (empty? predata) dd (if (vector? predata) predata (conj [] predata)))
          pd (if (empty? predata) predata (if (vector? predata) predata (conj [] predata)))
          ad (if (empty? pd) dd (reduce conj pd dd))]

      ;; (println "dd:" dd)

      ;; (println "PD::" pd)
      ;; (println "ad::" ad)


    ;;  TODO: think it would be best to move eager Post calls here (no sense in passing to meta)

    ;;  (re-frame/dispatch [::set-post-list-meta query-params md])
      ;; (cond (= method "Post.List")
      ;;       (re-frame/dispatch [::set-post-list-meta md])
      ;;       (= method "Post.ListBatch")
      ;;       (re-frame/dispatch [::set-post-list-batch-meta md]))

      (re-frame/dispatch [::set-post-list-meta md])
      (re-frame/dispatch [::set-post-list-data ad])
      (re-frame/dispatch [::http-complete])


      ;; (if (and (true? (:has_more md))
      ;;          (not= (:next_bookmark md) (:next_page_bookmark bmd)))
      ;;   (re-frame/dispatch [::http-get-post-list (merge query-params {:nbm (get-in md [:next_bookmark])}) ad])
      ;;   (when (not-empty ad)
      ;;     (interval-start)
      ;;     (re-frame/dispatch [::set-post-fb-data])
      ;;     (take! (raidize-result-data ad)
      ;;            (fn [raidized-result-data]
      ;;           ;;  (println "raidized-result-data::" raidized-result-data)
      ;;              (re-frame/dispatch [::set-fb-data :raid (:raid raidized-result-data)])))))



      (if (= (:next_bookmark md) (:next_page_bookmark bmd))
        (println "HIT: " (:next_bookmark md) " " (:next_page_bookmark bmd))
        (println "MISS: " (:next_bookmark md) " " (:next_page_bookmark bmd)))





      ;; (when (and (true? (:has_more md))
      ;;            (not= (:next_bookmark md) (:next_page_bookmark bmd)))
      ;;   (re-frame/dispatch [::http-get-post-list (merge query-params {:nbm (get-in md [:next_bookmark])}) ad interval-id]))

      ;; TODO: ::set-post-fb-data gets dispatched here but it gets data from db
      ;; which means it runs on all data on every post list success - perhaps it should be dd only
      ;; when being run from here and all data when run from interval code??
      (when (not-empty dd)
        ;; (interval-start)
        (re-frame/dispatch [::set-post-fb-data dd])
        ;; (re-frame/dispatch [::set-post-fb-data-eid-raid dd])
        (re-frame/dispatch [::admin-all-moderation-logs dd])
        ;; (take! (raidize-result-data dd)
        ;;        (fn [raidized-result-data]
        ;;          (println "raidized-result-data::" raidized-result-data)
        ;;         ;;  (re-frame/dispatch [::set-fb-data :raid (:raid raidized-result-data)])
        ;;         ;;  (re-frame/dispatch [::set-fb-data :raid (get-in raidized-result-data [:result :raid])])
        ;;          (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-result-data [:result])])

        ;;          ))

;; works - start
        ;; (loop [pp (partition-all 5 dd)]
        ;;   (let [p (first pp)]

        ;;     (take! (raidize-result-data p)
        ;;            (fn [raidized-result-data]
        ;;              (println "raidized-result-data::" raidized-result-data)
        ;;                           ;;  (re-frame/dispatch [::set-fb-data :raid (:raid raidized-result-data)])
        ;;                           ;;  (re-frame/dispatch [::set-fb-data :raid (get-in raidized-result-data [:result :raid])])
        ;;              (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-result-data [:result])])))

        ;;     (when-let [r (not-empty (rest pp))]
        ;;       (recur r))))
;; works - end

;; works - start
        ;; (let [eids (get-distinct-eids dd)]
        ;;   (loop [ps (partition-all 16 eids)]
        ;;     (let [p (first ps)]
        ;;       (take! (worker-pool/do! {:handler :raidize-eids, :arguments {:data p}})
        ;;              (fn [raidized-eids]
        ;;                (println "ps raidized-result-data::" raidized-eids)
        ;;                (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-eids [:result])])))
        ;;       (when-let [r (not-empty (rest ps))]
        ;;         (recur r)))))
;; works - end

        ;; works - start
        ;; distinct eids partitions (16 in each partition)
        ;; (loop [deps (partition-all 16 (get-distinct-eids dd))]
        ;;   (let [dep (first deps)]
        ;;     (take! (worker-pool/do! {:handler :raidize-eids, :arguments {:data dep}})
        ;;            (fn [raidized-eids]
        ;;              (println "ps raidized-result-data::" raidized-eids)
        ;;              (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-eids [:result])])))
        ;;     (when-let [r (not-empty (rest deps))]
        ;;       (recur r))))
        ;; works - end


        (when (and (true? (:has_more md))
                   (not= (:next_bookmark md) (:next_page_bookmark bmd))
                   (= @interval-id curr-interval-id))
          (re-frame/dispatch [::http-get-post-list (merge query-params {:nbm (get-in md [:next_bookmark])}) ad curr-interval-id]))))
    {}))





 (re-frame/reg-event-fx
  ::http-get-post-list-batch-success
  [(events/api-msg-interceptor {:mute-keys #{:result}})]
  (fn [{:keys [db]} [_ query-params predata data]]

    ;; (println "PREDATAAAA::" predata)
    ;; (println "_::" _)

    (let [sdd (get-in db [:posts :data])
          md (get-in data [:result :meta])
          ;; dd (get-in data [:result :data])
          dd (add-ws-to-refs (get-in data [:result :data]) (:ws query-params))
          ;; pd (if (empty? predata) predata (if (vector? predata) predata (conj [] predata)))
          pd (if (empty? predata) predata (if (vector? predata) predata (conj [] predata)))
          ad (if (empty? pd) dd (reduce conj pd dd))]

      ;; (println "PD::" pd)
      ;; (println "ad::" ad)



    ;;  TODO: think it would be best to move eager Post calls here (no sense in passing to meta)

    ;;  (re-frame/dispatch [::set-post-list-meta query-params md])
      ;; (cond (= method "Post.List")
      ;;       (re-frame/dispatch [::set-post-list-meta md])
      ;;       (= method "Post.ListBatch")
      ;;       (re-frame/dispatch [::set-post-list-batch-meta md]))

      (re-frame/dispatch [::set-post-list-batch-meta md])
      (re-frame/dispatch [::set-post-list-data ad])
      (re-frame/dispatch [::set-post-list-batch-datetime (.now js/Date)])
      (re-frame/dispatch [::http-complete])


      ;; (if (true? (:has_next_batch md))
      ;;   (re-frame/dispatch [::http-get-post-list (merge query-params {:nbm (get-in md [:next_batch_bookmark])}) ad])
      ;;   (when (not-empty ad)
      ;;     (interval-start)
      ;;     (re-frame/dispatch [::set-post-fb-data])
      ;;     (take! (raidize-result-data ad)
      ;;            (fn [raidized-result-data]
      ;;           ;;  (println "raidized-result-data::" raidized-result-data)
      ;;              (re-frame/dispatch [::set-fb-data :raid (:raid raidized-result-data)])))))

            ;; (when (true? (:has_next_batch md))
            ;;   (re-frame/dispatch [::http-get-post-list (merge query-params {:nbm (get-in md [:next_batch_bookmark])}) ad]))

      (when (not-empty dd)
        (interval-start)
        ;; (when (true? (:has_next_batch md))
        ;;   (re-frame/dispatch [::http-get-post-list (merge query-params {:nbm (get-in md [:next_batch_bookmark])}) ad @interval-id]))
        ;; (let [interval-id (interval-start)]
        ;;   (when (true? (:has_next_batch md))
        ;;     (re-frame/dispatch [::http-get-post-list (merge query-params {:nbm (get-in md [:next_batch_bookmark])}) ad interval-id])))
        (re-frame/dispatch [::set-post-fb-data dd])
        ;; (re-frame/dispatch [::set-post-fb-data-eid-raid dd])
        (re-frame/dispatch [::admin-all-moderation-logs dd])

        ;; (take! (raidize-result-data dd)
        ;;        (fn [raidized-result-data]
        ;;         ;;  (println "MEMEME" (get-in raidized-result-data [:result :raid]))
        ;;          (println "raidized-result-data::" raidized-result-data)
        ;;         ;;  (re-frame/dispatch [::set-fb-data :raid (:raid raidized-result-data)])
        ;;         ;;  (re-frame/dispatch [::set-fb-data :raid (get-in raidized-result-data [:result :raid])])
        ;;          (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-result-data [:result])])

        ;;          ))


;; this works - start
          ;; (loop [pp (partition-all 5 dd)]
          ;;   (let [p (first pp)]

          ;;     (take! (raidize-result-data p)
          ;;            (fn [raidized-result-data]
          ;;              (println "raidized-result-data::" raidized-result-data)
          ;;                       ;;  (re-frame/dispatch [::set-fb-data :raid (:raid raidized-result-data)])
          ;;                       ;;  (re-frame/dispatch [::set-fb-data :raid (get-in raidized-result-data [:result :raid])])
          ;;              (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-result-data [:result])])))

          ;;     (when-let [r (not-empty (rest pp))]
          ;;       (recur r))))
;; this works - end


              ;;  (worker-pool/do! {:handler :raidize-eids, :arguments {:data eids}})




;; also works - start
          ;; (let [eids (get-distinct-eids dd)]
          ;;   (loop [ps (partition-all 16 eids)]
          ;;     (let [p (first ps)]
          ;;       (take! (worker-pool/do! {:handler :raidize-eids, :arguments {:data p}})
          ;;              (fn [raidized-eids]
          ;;                (println "ps raidized-result-data::" raidized-eids)
          ;;                (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-eids [:result])])))
          ;;       (when-let [r (not-empty (rest ps))]
          ;;         (recur r)))))
;; also works - end



;; works - start
;; distinct eids partitions (16 in each partition)
        ;; (loop [deps (partition-all 16 (get-distinct-eids dd))]
        ;;   (let [dep (first deps)]
        ;;     (take! (worker-pool/do! {:handler :raidize-eids, :arguments {:data dep}})
        ;;            (fn [raidized-eids]
        ;;              (println "ps raidized-result-data::" raidized-eids)
        ;;              (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-eids [:result])])))
        ;;     (when-let [r (not-empty (rest deps))]
        ;;       (recur r))))
;; works - end




        ;; (let [interval-id (interval-start)]
        ;;   (when (true? (:has_next_batch md))
        ;;     (re-frame/dispatch [::http-get-post-list (merge query-params {:nbm (get-in md [:next_batch_bookmark])}) ad interval-id])))
        (when (and (true? (:has_next_batch md))
                   (not= (:next_batch_bookmark md) (:next_page_bookmark md)))
          (re-frame/dispatch [::http-get-post-list (merge query-params {:nbm (get-in md [:next_batch_bookmark])}) ad @interval-id])))


      )
    {}))


 (re-frame/reg-event-db
  ::http-get-post-list-failure
  [(events/api-msg-interceptor {})]
  (fn [db]
    (re-frame/dispatch [::http-complete])
    ;; (-> db
    ;;     ;; (assoc-in [:posts :message] "API connection failure!")
    ;;     (assoc-in [:message] "API connection failure!"))
    db))


(re-frame/reg-event-fx
 ::set-defaults-ws-fb
 (fn [e [_ ws]]
  ;; switching to local storage
   (fb/set-defaults-ws ws)
  ;;  (localstorage/set-item! "iris.defaults.ws" ws)
   (sessionstorage/set-item! "iris.defaults.ws" ws)
   {}))



(defn get-scopes-from-query-params [qp]
  (->
   (cond-> {}
     (:tag qp) (assoc :tag (str "#" (:tag qp)))
     (:user qp) (assoc :user (str "=" (:user qp)))
     (:ws qp) (assoc :ws (str "." (:ws qp)))
     (:cc qp) (assoc :cc (str ":" (:cc qp)))
     (:ip qp) (assoc :ip (str "^" (:ip qp)))
     (:geo qp) (assoc :geo (:geo qp))
     (:cookie qp) (assoc :cookie (:cookie qp))
     (:bfp qp) (assoc :bfp (:bfp qp))
     (:dfp qp) (assoc :dfp (:dfp qp))
     (:ua qp) (assoc :ua (:ua qp))
     (:mime qp) (assoc :mime (:mime qp))
     (:lang qp) (assoc :lang (:lang qp))
     (:thread qp) (assoc :thread (str "+" (:thread qp)))
     (:board qp) (assoc :board (:board qp))
     (:eid qp) (assoc :eid (:eid qp))
     (:id qp) (assoc :id (:id qp)) ;; thread id from thread panel route
     (:level qp) (assoc :level (str "level" (:level qp))) ;; level for thread panel
     )
   vals
   vec))

;; TODO: this often gets null so investigate why
(defn get-defaults-from-query-params [qp]
  ;; commented out ones are filters that must be present in url
  ;; perhaps comment them out from db as well? or just keep it there for defaults?
  ;; need ws here too, but passed into scopes somehow
  ;; NOTE: added/merged ws in ::query-params subs
  ;; NOTE: if page is not defined, starting with {:page 1} will default it to 1
  ;; perhaps others should be defaulted here as well
  (cond-> {:page 1 :layout nil :excerpt nil}
    ;; NOTE: ws here is experimental, perhaps it shouldn't be here
    (:ws qp) (assoc :ws (:ws qp))
    (:page qp) (assoc :page (int (:page qp)))
    (:limit qp) (assoc :limit (int (:limit qp)))
    ;; (:level qp) (assoc :level (int (:level qp)))
    ;; (:status qp) (assoc :status (:status qp))
    ;; (:flag qp) (assoc :flag (:flag qp))
    ;; (:staff qp) (assoc :staff (:staff qp))
    ;; (:sort qp) (assoc :sort (:sort qp))

    (:layout qp) (assoc :layout (:layout qp))

    (:excerpt qp) (assoc :excerpt (:excerpt qp))

    (:raw qp) (assoc :excerpt (:excerpt qp))))


;; this is problematic, some of these params should NOT stay until overwritten
;; perhaps just limit should be left? maybe not even that
(re-frame/reg-event-db
 ::set-posts-defaults-from-qp
 (fn [db [_ qp]]
   (let [defaults (get-defaults-from-query-params qp)]
     (when (and (:ws defaults)
                (not= (:ws defaults)
                      ;; (get-in db [:posts :ws])
                      (:ws db)))
      ;;  TODO: set-defaults-ws-fb happens only here, but if you change ws from analytics, default doesn't get set
      ;;  maybe this should be moved out to "::set-defaults-..." instead of "::set-posts-defaults-..."
       (re-frame/dispatch [::set-defaults-ws-fb (:ws defaults)]))
    ;;  (assoc-in db [:posts] (merge (:posts db) defaults))
    ;;  Note: we moved :ws to topmost level. So...
    ;;  - dissoc :ws from defaults so it doesn't get merged under :posts
    ;;  - assoc-in topmost [:ws] but only if it is provided in defaults (don't want to override if it's not already there)
    ;; Keep in mind that depending how it's called defaults might be empty or not, for example:
    ;; (:ws defaults) {:page 1, :layout nil, :excerpt yes, :ws TSC, :limit 50}
    ;; (:ws defaults) {:page 1, :layout nil, :excerpt nil}
     (-> db
         (assoc-in [:posts] (merge (:posts db) (dissoc defaults :ws)))
         (assoc-in [:ws] (or (:ws defaults) (:ws db)))))))


(def prev-query-params (atom nil))
(def prev-panel (atom nil))

;; cast only params you want - not needed - delete
;; (def typetrans {:limit #(int %) :b #(Double/parseDouble %)})
;; (reduce-kv #(update-in %1 [%2] %3) input typetrans)

(re-frame/reg-cofx
 :header-loaded
 (fn [cofx]
   (let [[_ qp ruid] (:event cofx)]
     (assoc cofx :header-loaded (= ruid (get-in cofx [:db :posts :header :ruid]))))))

;; TODO: could refactor panel vs prev-panel check into another coeffect
(re-frame/reg-cofx
 :pq
 (fn [cofx _]
   (let [[_ query-params] (:event cofx)
         ws (get-in cofx [:db :ws])
         limit (get-in cofx [:db :posts :limit])
         panel (get-in cofx [:db :route :panel])
         prev-panel (get-in cofx [:db :prev-route :panel])
         prev-query-params (get-in cofx [:db :prev-route :route :query-params])]

    ;;  (println "cofx ----------------------------")
    ;;  (println "cofx query-params" query-params)
    ;;  (println "cofx prev-query-params" prev-query-params)
    ;;  (println "cofx qp" (utils/map-kv str (apply dissoc query-params [:layout :excerpt :raw :ws :limit])))
    ;;  (println "cofx pqp" (utils/map-kv str (apply dissoc prev-query-params [:layout :excerpt :raw :ws :limit])))
    ;;  (println "cofx limit" limit (:limit query-params) (= limit (int (:limit query-params))))

    ;;  Notes:
    ;;  query-params may contain params that are not even in url, for example  {:ws TLO, :limit 50, :board +1tukFroX, :level 2, :pq-check false}
    ;;  or :nbm Ck0KFwoKY3JlYXRlZF9kdBIJCLzd68G7xPoCEi5qDHN-cmstZ2VhLWRldnIYCxIEUG9zdCIOKjFpWUtkTFhPLTNkYWQMogEDZGV2GAAgAQ==
    ;;  :nbm (inserted while batch loading)
    ;;  if query-params and prev-query-params are not the same (unwanted params excluded)
    ;;  pass into cofx context param load posts :pq-load-posts-ok to load posts
    ;;  used "apply" to flatten the collection [:layout] into argument list
    ;;  casted as string so :limit 50 and :limit "50" would be equal (first load issue)

    ;; :pq-check false? - if coming from thread-flow (first load OP then the replies) we let it load
    ;; regardless if the previous query params are the same or not.
    ;; That way if replying multiple times to the same OP the posts will be loaded (otherwise won't)
    ;; 12/21/22 when adding table view to thread panel, noticed that posts were reloading - even though stitching layout shouldn't do that.
    ;; The reason why it reloads in thread is because of :pq-check set to false in thread flow

    ;;  testing ws and limit from db against ws,limit from query-params because on first load they are not set in url/query-params however on all next btn clicks they are in url
    ;;  later excluding them from from qp vs pqp because it is possible that they are in query-params and NOT in prev-query-params (that doesn't matter though because they are set in db, which is previously checked)

     (when (or (false? (:pq-check query-params))
               (not= ws (:ws query-params))
               (not= limit (int (:limit query-params)))
               (not= panel prev-panel)
               (not= (utils/map-kv str (apply dissoc query-params [:layout :excerpt :raw :ws :limit]))
                     (utils/map-kv str (apply dissoc prev-query-params [:layout :excerpt :raw :ws :limit]))))
       (assoc cofx :pq-load-posts-ok true)))))

 (re-frame/reg-event-fx
  ::http-get-post-list
  ;; (fn [cofx e [_ query-params]]
  [(re-frame/inject-cofx :pq)]
  (fn [{:keys [db] :as cofx} [e query-params predata interval-id]]

    ;; (println "PREDATA PASSED TO POST-LIST::" predata)

    ;; TODO: in case of excerpt yes - interval is stopped but not continued
    ;; needs to be moved inside :pq-load-posts-ok true?
    ;; TODO: revisit interval-end, because of lazy loading things changed
    ;; (interval-end)

    ;; perhaps this should happen elsewhere, currently Post.List runs before db gets updated with defaults
    ;; TODO: since batch is run first, is there a need to run this here??
    (re-frame/dispatch [::set-posts-defaults-from-qp query-params])

    ;; flag and staff params need to be added to post-rpc but api currently doesn't support it

    ;; for layout: perhaps some kind of filter here which compares state in db with query params. Trigger Post.List load only if crucial params changed not the one like "layout". Also interval need to be taken into consideration, not sure if it is needed in table view, but again maybe triggering it once user switched back to list is unnecessary complication
    ;; another option is maybe some kind of skip load atom set to true by table/list buttons, loaded in post.list effect as cofx :skip-load and reset to false


    ;; (println (get-in e [:db :posts]))
    ;; (println "select-keys:::" (select-keys (get-in e [:db :posts]) (into [] (keys query-params))))

    ;; save prev-query-parameters and if same with new ones (excluding layout) do not load - possible problem with scroll loading although we maybe could use bookmarks with params
    ;; maybe in interceptor

    ;; (.log js/console @prev-query-params)
    ;; (.log js/console (dissoc query-params :layout))


;; TODO: there is a problem when comparing :limit 50 and :limit "50" (int vs string)
    ;; next time around that problem dissapears but first time is present
    ;; (when (not= (dissoc query-params :layout) @prev-query-params)

      ;; (reset! prev-query-params (dissoc query-params :layout))

    ;; (println "QUERY PARAMS::" query-params)

    (when (true? (:pq-load-posts-ok cofx))
    ;; (when (and (true? (:pq-load-posts-ok cofx))
    ;;            (= @interval-id interval-id))



      (events/post-rpc {:jsonrpc "2.0"
                        :id 0
                        ;; :method "Post.List"
                        :method "Post2a.List"
                        :params {:options {:debug false}
                                 :data (merge {:include_screening_status true
                                               :scopes (get-scopes-from-query-params query-params)
                                        ;; :level (int (or (:level query-params) (get-in db [:posts :level])))
                                        ;; :level nil
                                               :status (or (:status query-params) (get-in db [:posts :status]))
                                               :sort_by (or (:sort query-params) (get-in db [:posts :sort]))
                                        ;; :after ""
                                        ;; :before ""
                                               :bookmark (:nbm query-params)
                                      ;; had to eliminate pulling page from db because it pulls 11 (::set-posts-defaults doesn't get executed in time)
                                      ;; :page (int (or (:page query-params) (get-in e [:db :posts :page])))
                                        ;; :page (int (or (:page query-params) 1))
                                        ;; :limit (int (or (:limit query-params) (get-in db [:posts :limit])))
                                      ;; :limit (int (or (:n query-params) (get-in e [:db :posts :limit])))

                                               :limit (if (< (int (:limit query-params)) 50) (int (:limit query-params)) 50)
                                               :ruids_only false}
                                              (when-let [staff (cond (= (:staff query-params) "yes") "yes"
                                                                     (= (:staff query-params) "no") "no"
                                                                     :else nil)]
                                                {:staff staff})
                                              (when-let [flag (:flag query-params)]
                                                {:flag flag}))

                            ;;    (merge {:bookmark ""
                            ;;            :limit (if-not (zero? (int (:n query-params))) (int (:n query-params)) 50)
                            ;;            :page (if-not (zero? (int (:page query-params))) (int (:page query-params)) 1)}
                            ;;           (when-let [order (:order query-params)]
                            ;;             {:order order})
                            ;;           (when-let [scope (:scope query-params)]
                            ;;             {:scope scope}))
                                 }}
                       [::http-get-post-list-success query-params predata interval-id]
                       [::http-get-post-list-failure]
                       [::events/track-request "Post.List"]))))


(re-frame/reg-event-fx
 ::http-get-post-list-debounced
 (fn [e [_ query-params]]
   {::events/dispatch-debounce ["Post.List"
                                [::http-get-post-list query-params]
                                1000]}))



;; Calling RPC at URL: http://localhost:8083/rpc
;; JSON payload:
;;  {
;;     "method": "Post.Get",
;;     "params": {
;;         "data": [
;;             "@OP+1gTM1g2O"
;;         ],
;;         "options": {
;;             "debug": false
;;         }
;;     },
;;     "id": 0,
;;     "jsonrpc": "2.0"
;; }
;; OK. Post found: @OP+1gTM1g2O


(re-frame/reg-event-fx
 ::http-get-post-success
 [(events/api-msg-interceptor
   ;;  ruid to link turned off per request in IRS-54 
   ;;  {:result-modifier-fn (fn [msg] (ruid-to-ahref msg))}
   {})]
 (fn [{:keys [db]} [_ data]]
   ;;  TODO: probably should be refactored into a function, it is used in search as well as posts lists
   (if-let [d (get-in data [:result :data])]
     (do
       ;; post found, process data, update db in effect
       ;; get post votes/reactions, replies (TODO: this could be turned into function, it's called from other places we well)
      ;;  (let [ws (:ws d)
      ;;        forum (subs (:forum d) 1 (.indexOf (:forum d) "."))
      ;;        thread (:thread d)
      ;;        nick (subs (:id d) 0 (.indexOf (:id d) "+"))]
      ;;    (fb/get-post-votes ws forum thread nick on-update-fb-data-votes)
      ;;    (when (= nick "@OP")
      ;;      (fb/get-replies ws thread on-update-fb-data-replies)))

       (let [dd (conj [] d)]
         (when (not-empty dd)
           ;; get post votes/reactions, replies
           (re-frame/dispatch [::set-post-fb-data dd])
           ;; raidize
          ;;  (take! (raidize-result-data dd true)
          ;;         (fn [raidized-result-data]
          ;;           ;; (re-frame/dispatch [::set-fb-data :raid (:raid raidized-result-data)])
          ;;           (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-result-data [:result])])))
          ;;  (re-frame/dispatch [::set-post-fb-data-eid-raid dd])

           ))

       {:db (-> db
                (update-in [:posts :screening-status] merge (get-in data [:result :meta :screening_status])))})
     (do
       ;; post not found, process error message, return empty effect
       (println (get-in data [:error :message]))
       {}))))


(re-frame/reg-event-fx
 ::http-get-post-failure
 [(events/api-msg-interceptor {})]
 (fn [_ data]))


;; cofx injection checks if already loaded?
 (re-frame/reg-event-fx
  ::http-get-post
  (fn [e [_ ruid]]
    (events/post-rpc {:jsonrpc "2.0"
                      :id 0
                      ;; :method "Post.Get"
                      :method "Post2a.Get"
                      :params {:options {:debug false}
                               :data {:ruid ruid
                                      :include_screening_status true}}}
                     [::http-get-post-success]
                     [::http-get-post-failure])))



;; perhaps eid/reid and fb data could be added as effects to rules for processing
(defn thread-flow
  [query-params]
  {:first-dispatch [::http-get-post (str "@OP" (:board query-params))]              ;; what event kicks things off ?
   :rules [;; a set of rules describing the required flow
           {:when :seen?
            :events ::http-get-post-success
            :dispatch-fn (fn [[e result-data]]
                           (if (:error result-data)
                             [[::error-events/set-error {:title "Error: Post not found!"
                                                         :message (get-in result-data [:error :message])
                                                         :a-href "/posts"
                                                         :a-txt "Return to Posts"}]]
                             [[::http-get-post-list-batch
                               (conj query-params {:pq-check false :ws (get-in result-data [:result :data :ws])})
                                                         ;;  (conj [] (get-in result-data [:result :data]))
                               (add-ws-to-refs (conj [] (get-in result-data [:result :data])) (get-in result-data [:result :data :ws]))]
                              [::admin-all-moderation-logs (conj [] (get-in result-data [:result :data]))]]))}
           {:when :seen?
            :events ::http-get-post-list-batch-success
            ;; :events ::http-get-post-list-success
           :halt? true
           }
          ;;  {:when :seen-any-of? :events [:fail-X :fail-Y :fail-Z] :dispatch [:app-failed-state] :halt? true}
           ]})


(re-frame/reg-event-fx                    ;; note the -fx
 ::http-get-thread                          ;; usage: (dispatch [:boot])  See step 3
;;  (fn [_ _]
 [events/redo-interceptor]
 (fn [e [_ query-params]]
   {:async-flow (thread-flow query-params)})) ;; kick off the async process






(defn reload-post-flow
  [ruid]
  {:first-dispatch [::http-get-post ruid]
   :rules [{:when :seen?
            :events ::http-get-post-success
            :dispatch-fn (fn [[e result-data]]
                           [[::update-posts-data-row ruid (get-in result-data [:result :data])]
                            [::http-complete]])
            :halt? true}]})


(re-frame/reg-event-fx
 ::http-reload-post
 (fn [e [_ ruid]]
   {:async-flow (reload-post-flow ruid)}))




;; TODO: function not used anymore but careful - most likely should be "mapv" instead of map
(defn post-action-db-update-status [db data id id-suffix old-reply-status new-reply-status]
  (assoc-in db [:posts :data]
            (map #(cond (= id (:id %))
                        (do
                          ;; (println "id = id so conj result data" (get-in data [:result :data]))
                          (conj % (get-in data [:result :data])))
                        (and (= (str "+" id-suffix) (:thread %))
                             (= (:status %) old-reply-status))
                        (do
                          ;; (println "id NOT= id so new reply status" new-reply-status)
                          (conj % {:status new-reply-status}))
                        :else
                        %)
                 (get-in db [:posts :data]))))


;; TODO: function not used anymore but careful - most likely should be "mapv" instead of map
(defn post-action-db-update [db data]
  ;; (if-let [id (get-in data [:result :data :id])]
  ;;   (assoc-in db [:posts :data]
  ;;             (map #(if (= id (:id %))
  ;;                     (conj % (get-in data [:result :data]))
  ;;                     %)
  ;;                  (get-in db [:posts :data])))
  ;;   db)

    (if-let [
            ;;  id (get-in data [:result :data :id])
            ;;  id (get-in data [:result :outcome :data :post :ruid])
             id (get-in data [:result :data :ruid])
             ]
      (let [id-parts (string/split id #"\+")
            id-prefix (first id-parts)
            id-suffix (second id-parts)
            ;; status (get-in data [:result :data :status])
            ;; status (get-in data [:result :outcome :data :post :status])
            status (get-in data [:result :data :status])
            uid (:uid @globals/jwt-payload)]
        (cond (and (= status "R")
                   (= id-prefix "@OP"))
              (assoc-in db [:posts :data]
                        (map #(cond (= id (:id %))
                                    ;; (conj % (get-in data [:result :data]) {:qc true :qc_by uid})
                                    (conj % {:status status :qc true :qc_by uid})
                                    (and (= (str "+" id-suffix) (:thread %))
                                         (= (:status %) "P"))
                                    (conj % {:status "T"})
                                    :else
                                    %)
                             (get-in db [:posts :data])))
              ;; (post-action-db-update-status db data id id-suffix "P" "T")
              (and (= status "P")
                   (= id-prefix "@OP"))
              (assoc-in db [:posts :data]
                        (map #(cond (= id (:id %))
                                    ;; (conj % (get-in data [:result :data]) {:qc true :qc_by uid})
                                    (conj % {:status status :qc true :qc_by uid})
                                    (and (= (str "+" id-suffix) (:thread %))
                                         (= (:status %) "T"))
                                    (conj % {:status "P"})
                                    :else
                                    %)
                             (get-in db [:posts :data])))
              ;; (post-action-db-update-status db data id id-suffix "T" "P")
              :else
              (assoc-in db [:posts :data]
                        (map #(if (= id (:id %))
                                ;; (conj % (get-in data [:result :data]) {:qc true :qc_by uid})
                                (conj % {:status status :qc true :qc_by uid}) ; this is wrong, missing result data (outcome version)
                                %)
                             (get-in db [:posts :data]))))
        ;; (println "id-parts:" id-parts)
        ;;       (assoc-in db [:posts :data]
        ;;                 (map #(if (= id (:id %))
        ;;                         (conj % (get-in data [:result :data]))
        ;;                         %)
        ;;                      (get-in db [:posts :data])))
        )

      db)
  )

;; TODO: analize get-post-action-outcome-updated-db, perhaps things could be simplified greatly using decode state and updating like we do in post-logs-update
;; get-post-action-outcome-updated-db - multimethods - START:
;; TODO: multimethods and posts state data will need to be updated for isLocked and isHidden...
;; ...so :hidden and :replying_disabled become :isHidden and :isLocked in both rpc result handling and [:posts :data]
(defmulti get-post-action-outcome-updated-db
  (fn [db data]
    (let [method (get-in data [:result :method])]
      (cond (contains? #{"Post.Approve"
                         "Post.Remove"
                         "Post.QCFail"
                         "Post.QCPass"
                         "Post2.Approve"
                         "Post2.Remove"
                         "Post2.QCFail"
                         "Post2.QCPass"
                         "Post.Publish"
                         "Post2.Publish"} method)
            :status
            (contains? #{"Post.Hide"
                         "Post.Unhide"
                         "Post2.Hide"
                         "Post2.Unhide"} method)
            ;; :hidden
            :isHidden
            (contains? #{"Post.Unlock"
                         "Post.Lock"
                         "Post2.Unlock"
                         "Post2.Lock"} method)
            ;; :replying_disabled
            :isLocked
            ))))



(defmethod get-post-action-outcome-updated-db :status [db data]
  (if-let [ruid (get-in data [:result :data :ruid])]
    (let [ruid-parts (string/split ruid #"\+")
          ruid-prefix (first ruid-parts)
          ruid-suffix (second ruid-parts)
          status (get-in data [:result :data :status])
          uid (:uid @globals/jwt-payload)]
      (assoc-in db [:posts :data]
                (mapv #(cond
                        ;;  update state for post action was performed on
                         (= ruid (:ruid %))
                         (conj %
                               {:status status
                                :isQc true
                                :qc_by uid})

                        ;;  if post was OP and action performed was R, set replies to status T
                         (and (and (= status "R") (= ruid-prefix "@OP"))
                              (= (str "+" ruid-suffix) (:thread %))
                              (= (:status %) "P"))
                         (conj % {:status "T"})

                        ;;  if post was OP and action performed was P, set replies to P
                         (and (= status "P") (= ruid-prefix "@OP")
                              (= (str "+" ruid-suffix) (:thread %))
                              (= (:status %) "T"))
                         (conj % {:status "P"})

                        ;;  nothing to do, return post data as is
                         :else
                         %)
                      (get-in db [:posts :data]))))
    db))





(defmethod get-post-action-outcome-updated-db
  ;; :hidden
  :isHidden
  [db data]
  (if-let [;;  id (get-in data [:result :outcome :data :post :ruid])
          ;;  id (get-in data [:result :outcome :data :ruid])
           ruid (get-in data [:result :data :ruid])
           ]
    (let [
          ;; hidden (get-in data [:result :outcome :data :post :hidden])
          hidden (get-in data [:result :data :isHidden])
          uid (:uid @globals/jwt-payload)]
      (assoc-in db [:posts :data]
                (mapv #(if
                      ;;  (= id (:id %))
                       (= ruid (:ruid %))
                        (conj % {
                                ;;  :hidden hidden
                                ;;  :qc true
                                ;;  :qc_by uid
                                 :isHidden hidden
                                 })
                        %)
                     (get-in db [:posts :data]))))
    db))


(defmethod get-post-action-outcome-updated-db
  ;; :replying_disabled
  :isLocked
  [db data]
  (if-let [
          ;;  id (get-in data [:result :outcome :data :post :ruid])
          ;;  id (get-in data [:result :outcome :data :ruid])
           ruid (get-in data [:result :data :ruid])
           ]
    (let [
          ;; replying-disabled (get-in data [:result :outcome :data :post :replyingDisabled])
          locked (get-in data [:result :data :isLocked])
          uid (:uid @globals/jwt-payload)]
      (assoc-in db [:posts :data]
                (mapv #(if
                      ;;  (= id (:id %))
                       (= ruid (:ruid %))
                        (conj % {;;  :replying_disabled replying-disabled
                                ;;  :qc true
                                ;;  :qc_by uid
                                 :isLocked locked})
                        %)
                     (get-in db [:posts :data]))))
    db))

;; get-post-action-outcome-updated-db - multimethods - END








(defn moderation-log [data]
  (fb/push-admin-moderation-log data)
  )


(re-frame/reg-event-db
 ::push-admin-moderation-log
 (fn [db [_ data]]
   (update-in db [:posts :moderation-log-data] conj data)))

;; (defn get-log-data-from-post-action-outcome [data]
;;   (let [method (get-in data [:result :method])]
;;     (cond (contains? #{"Post.Approve" "Post.Remove" "Post.QCFail" "Post.QCPass"} method)
;;           {:status (get-in data [:result :outcome :data :post :status])}
;;           (contains? #{"Post.Hide" "Post.Unhide"} method)
;;           {:hidden (get-in data [:result :outcome :data :post :hidden])}
;;           (contains? #{"Post.EnableReplying" "Post.DisableReplying"} method)
;;           {:replying_disabled (get-in data [:result :outcome :data :post :replyingDisabled])})))


;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;; this function receives http-post-action-success's result data as argument
;; to extract log data to be inserted in firebase and update local state moderator logs
;; NOTE: this doesn't update [:posts :data], only moderator logs (firebase and app state)...
;; ...it is the ""get-post-action-outcome-updated-db"" that updates [:posts :data]!!!
;; we can use [:outcome :data :state] which has "status, qc, hidden, locked" info in abbrev. form
;; TODO: once [:posts :data] is updated, :hidden and replying_disabled will need to be updated too!!!
;; (defn get-log-data-from-post-action-outcome [data]
;;   (let [method (get-in data [:result :method])
;;         ;; post (get-in data [:result :outcome :data :post])
;;         data (get-in data [:result :outcome :data])
;;         ]
;;     (cond (contains? #{"Post.Approve"
;;                        "Post.Remove"
;;                        "Post.QCFail"
;;                        "Post.QCPass"
;;                        "Post2.Approve"
;;                        "Post2.Remove"
;;                        "Post2.QCFail"
;;                        "Post2.QCPass"} method)
;;           (select-keys data [:ruid :status :timeUpdated])
;;           (contains? #{"Post.Hide"
;;                        "Post.Unhide"
;;                        "Post2.Hide"
;;                        "Post2.Unhide"} method)
;;           ;; (select-keys post [:ruid :hidden])
;;           ;; (select-keys data [:ruid :isHidden])
;;           ;; {:ruid (:ruid data) :hidden (:isHidden data)}
;;           (select-keys data [:ruid :isHidden :timeUpdated])
;;           ;; (contains? #{"Post.EnableReplying" "Post.DisableReplying"} method)
;;           (contains? #{"Post2.Unlock" "Post2.Lock"} method)
;;           ;; {:ruid (:ruid data) :replying_disabled (:replyingDisabled post)}
;;           ;; {:ruid (:ruid data) :replying_disabled (:isLocked data)}
;;           (select-keys data [:ruid :isLocked :timeUpdated])
;;           )))


(def method-to-action-map {:Approve "APPROVE"
                           :Remove "REMOVE"
                           :QCFail "QC_FAIL"
                           :QCPass "QC_PASS"
                           :Hide "HIDE"
                           :Unhide "UNHIDE"
                           :Lock "LOCK"
                           :Unlock "UNLOCK"
                           :Publish "PUBLISH"})

;; (defn get-log-data-from-post-action-response-data [data]
;;   (let [method (get-in data [:result :method])
;;         action (get method-to-action-map (keyword (second (string/split method #"\."))))
;;         ruid (get-in data [:result :outcome :data :ruid])
;;         state0 (get-in data [:result :antecedent :state])
;;         state1 (get-in data [:result :outcome :data :state])
;;         dt (get-in data [:result :outcome :data :timeUpdated])
;;         ms (.valueOf (new js/Date dt))]
;;     {:action action
;;      :ruid ruid
;;      :dt dt
;;      :ms ms
;;      :state0 state0
;;      :state1 state1}))

(defn get-log-data-from-post-action-response-data [data]
  (let [method (get-in data [:result :method])
        action (get method-to-action-map (keyword (second (string/split method #"\."))))
        ruid (get-in data [:result :data :ruid])
        state0 (get-in data [:result :antecedent :state])
        state1 (get-in data [:result :data :state])
        dt (get-in data [:result :data :timeUpdated])
        ms (.valueOf (new js/Date dt))]
    ;; TODO: had to add check for ruid, state0 and state1 becase Post2.Publish is not returning these values in api response
    ;; therefore it was crashing app when personal moderator logs were clicked on
    (when (and ruid state0 state1)
      {:action action
       :ruid ruid
       :dt dt
       :ms ms
       :state0 state0
       :state1 state1})))

(re-frame/reg-event-db
 ::http-post-action-success
 [(events/api-msg-interceptor {:id :http-post-action-success-api-msg-interceptor
                               :result-modifier-fn (fn [msg] (ruid-to-ahref msg))})]
;;  (fn [db [_ data]]
 (fn [db [_ ruid data]]
   (re-frame/dispatch [::http-complete])

  ;;  [:result :method]
  ;;  Post.Approve
  ;;  Post.Remove
  ;;  Post.QCFail
  ;;  Post.QCPass
  ;;  Post.Hide
  ;;  Post.Unhide
  ;;  Post.EnableReplying
  ;;  Post.DisableReplying


  ;;  [:result :outcome :data :post :ruid] ; @OP+1ozRZgNl
  ;;  [:result :outcome :data :post :status] ; P
  ;;  [:result :outcome :data :post :replyingDisabled] ; true ; false
  ;;  [:result :outcome :data :post :hidden] ; true ; false

  ;;  (let [method (get-in data [:result :method])]
  ;;    (cond (= method (or "Post.Hide" "Post.Unhide"))
  ;;          {:hidden (get-in data [:result :outcome :data :post :hidden]) :ws (:ws db)}
  ;;          (= method (or "Post.Approve" "Post.Remove" "Post.QCFail" "Post.QCPass"))
  ;;          {:status (get-in data [:result :outcome :data :post :status]) :ws (:ws db)}
  ;;          (= method (or "Post.EnableReplying" "Post.DisableReplying"))
  ;;          {:replying_disabled (get-in data [:result :outcome :data :post :replyingDisabled]) :ws (:ws db)}))


;; /admin-sessions/all/moderation/TLO/@7cov+1oBepdPc/-NetshI3ynQNOIfSZzLF
;; {
;;   "action": "REMOVE",
;;   "dt": "2023-09-21T22:36:04Z",
;;   "ms": 1695335764979,
;;   "ruid": "@7cov+1oBepdPc",
;;   "state0": "P",
;;   "state1": "Rq",
;;   "uid": "nedim"
;; }

;; /admin-sessions/nedim/moderation/TLO/-NesUsHKbaHX22NS8avL
;; {
;;   "action": "UNLOCK",
;;   "dt": "2023-09-21T16:07:59Z",
;;   "ms": 1695312479264,
;;   "ruid": "@OP+1oBepdPc",
;;   "state0": "Phlq",
;;   "state1": "Phq"
;; }


  ;;  (when-let [outcome-log-data (get-log-data-from-post-action-outcome data)]
  ;;    (println "outcome-log-data:" outcome-log-data)
  ;;    (let [log-data (assoc outcome-log-data :ws (:ws db))]
  ;;      (println "log-data::" log-data)
  ;;     ;;  (fb/push-admin-moderation-log log-data) ;; this will be written from backend
  ;;     ;;  (fb/push-admin-all-moderation-log log-data) ;; this will be written from backend
  ;;      (re-frame/dispatch [::push-admin-moderation-log (assoc log-data :datetime (.getTime (js/Date.)) :uid (:uid @globals/fbjwt-payload))])
  ;;      (let [old-log-data (get-in db [:posts :all-moderation-log-data (keyword (:id log-data))])
  ;;            new-log-data (conj old-log-data (assoc log-data :datetime (.getTime (js/Date.)) :uid (:uid @globals/fbjwt-payload)))]
  ;;        (re-frame/dispatch [::set-admin-all-moderation-logs (:id log-data) new-log-data]))))
   (when-let [log-data (get-log-data-from-post-action-response-data data)]
  ;; (println "outcome-log-data:" outcome-log-data)
  ;; (let [log-data (assoc outcome-log-data :ws (:ws db))]
      ;;  (fb/push-admin-moderation-log log-data) ;; this will be written from backend
      ;;  (fb/push-admin-all-moderation-log log-data) ;; this will be written from backend
    (re-frame/dispatch [::push-admin-moderation-log
                        ;; (assoc log-data :ms (.valueOf (new js/Date (:timeUpdated log-data))) :uid (:uid @globals/fbjwt-payload))
                        log-data
                        ])
    (let [old-log-data (get-in db [:posts :all-moderation-log-data (keyword
                                                                    ;; (:id log-data)
                                                                    (:ruid log-data)
                                                                    )])
          new-log-data (conj old-log-data (assoc log-data
                                                ;;  :datetime (.getTime (js/Date.))
                                                 :uid (:uid @globals/fbjwt-payload)))]
      (re-frame/dispatch [::set-admin-all-moderation-logs
                          ;; (:id log-data)
                          (:ruid log-data)
                          new-log-data]))
    ;; )
     )


  ;;  START HERE:::
  ;;  (when-let [result-data (get-in data [:result :data])]
  ;;    (println "result-data from post action success: " result-data)

  ;;    (when (or (contains? result-data :status)
  ;;              (contains? result-data :replying_disabled)
  ;;              (contains? result-data :hidden))

  ;;      (let [;;  log-data (conj result-data {:ws (:ws db)})
  ;;            log-data (-> result-data
  ;;                         (dissoc :warning)
  ;;                         (conj {:ws (:ws db)}))]
  ;;        (fb/push-admin-moderation-log log-data)
  ;;        (fb/push-admin-all-moderation-log log-data)
  ;;        ;; TODO: implemented but maybe this is not needed?
  ;;        ;; or maybe if we do keep it, it needs to track logins as well as actions in other sections
  ;;        ;; (fb/set-last-action log-data)

  ;;        (re-frame/dispatch [::push-admin-moderation-log (assoc log-data :datetime (.getTime (js/Date.)) :uid (:uid @globals/fbjwt-payload))])

  ;;          ;;  set log locally so UI updates right away
  ;;        (let [old-log-data (get-in db [:posts :all-moderation-log-data (keyword (:id log-data))])
  ;;              new-log-data (conj old-log-data (assoc log-data :datetime (.getTime (js/Date.)) :uid (:uid @globals/fbjwt-payload)))]
  ;;         ;;  (println "NEW::" new-log-data)
  ;;          (re-frame/dispatch [::set-admin-all-moderation-logs (:id log-data) new-log-data]))


  ;;              ;;  (update-in m [:b :c] conj "uu")

  ;;     ;;  (println "ADDED MODERATION LOG:" (update-in db [:posts :moderation-log-data] conj (assoc log-data :datetime (.getTime (js/Date.)) :uid (:uid @globals/fbjwt-payload))))
  ;;        )))

  ;;==========================================================================
  ;;  S->P issue:
  ;;  status state may have changed on the backend since the posts were loaded
  ;;  therefore it's best to check for "S" status in local state - antecendent may have updated already
  ;;  also "P" in outcome is too narrow. P guarantees that content is there, but content also be the case with some other statuses (though not always)

  ;;  Reload post it it was in submitted state (= :status "S") and action was performed on it
  ;;  That should solve content vs content_raw issue (S has content_raw only)
  ;;  Add content_raw fallbacks to view just in case
   (when-let [_d (first (filter #(= ruid (:ruid %)) (get-in db [:posts :data])))]
    ;; Note: this was the original idea, when S->P reload post but it's too narrow...
    ;; problem is what happens when the status has already changed on backend so you call it
    ;; and it returns something like P->P
    ;;  (when (and
    ;;         (= (get-in data [:result :antecedent :status]) "S")
    ;;         (= (get-in data [:result :outcome :data :status]) "P"))
    ;;    (re-frame/dispatch [::http-reload-post ruid]))
    ;; Therefore, if local state is showing S and server returns !=S then reload post:
     (when (and
            (= (:status _d) "S")
            (not= (get-in data [:result :data :status]) "S"))
       (re-frame/dispatch [::http-reload-post ruid])))
;; ==========================================================================



   (-> db
      ;;  (assoc-in
      ;;   ;; [:posts :message]
      ;;   [:message]
      ;;   (or (get-in data [:result :message]) (get-in data [:error :message])))
      ;;  (post-action-db-update data)
       (get-post-action-outcome-updated-db data)
       )))


(re-frame/reg-event-db
 ::http-post-action-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;  (-> db
   ;;     ;;  (assoc-in [:posts :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))




(re-frame/reg-event-fx
 ::http-post-remove
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                    ;;  :method "Post.Remove"
                     :method "Post2.Remove"
                     :params {:options {:debug false}
                              :data {:enqueue false
                                     :ruid ruid}}}
                    ;; [::http-post-action-success]
                    [::http-post-action-success ruid]
                    [::http-post-action-failure])))


(re-frame/reg-event-fx
 ::http-post-approve
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                    ;;  :method "Post.Approve"
                     :method "Post2.Approve"
                     :params {:options {:debug false}
                              :data {:enqueue false
                                     :ruid ruid}}}
                    ;; [::http-post-action-success]
                    [::http-post-action-success ruid]
                    [::http-post-action-failure])))


(re-frame/reg-event-fx
 ::http-post-hide
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                    ;;  :method "Post.Hide"
                     :method "Post2.Hide"
                     :params {:options {:debug false}
                              :data ruid}}
                    ;; [::http-post-action-success]
                    [::http-post-action-success ruid]
                    [::http-post-action-failure])))


(re-frame/reg-event-fx
 ::http-post-unhide
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                    ;;  :method "Post.Unhide"
                     :method "Post2.Unhide"
                     :params {:options {:debug false}
                              :data ruid}}
                    ;; [::http-post-action-success]
                    [::http-post-action-success ruid]
                    [::http-post-action-failure])))


(re-frame/reg-event-fx
 ::http-post-enable-replying
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                    ;;  :method "Post.EnableReplying"
                    ;;  :method "Post2.EnableReplying"
                     :method "Post2.Unlock"
                     :params {:options {:debug false}
                              :data ruid}}
                    ;; [::http-post-action-success]
                    [::http-post-action-success ruid]
                    [::http-post-action-failure])))


(re-frame/reg-event-fx
 ::http-post-disable-replying
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                    ;;  :method "Post.DisableReplying"
                    ;;  :method "Post2.DisableReplying"
                     :method "Post2.Lock"
                     :params {:options {:debug false}
                              :data ruid}}
                    ;; [::http-post-action-success]
                    [::http-post-action-success ruid]
                    [::http-post-action-failure])))


(re-frame/reg-event-fx
 ::http-post-qc-pass
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                    ;;  :method "Post.QCPass"
                     :method "Post2.QCPass"
                     :params {:options {:debug false}
                              :data [ruid]}}
                    ;; [::http-post-action-success]
                    [::http-post-action-success ruid]
                    [::http-post-action-failure])))


(re-frame/reg-event-fx
 ::http-post-qc-fail
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                    ;;  :method "Post.QCFail"
                     :method "Post2.QCFail"
                     :params {:options {:debug false}
                              :data [ruid]}}
                    ;; [::http-post-action-success]
                    [::http-post-action-success ruid]
                    [::http-post-action-failure])))


(re-frame/reg-event-fx
 ::http-post-publish
 (fn [e [_ ruid]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                    ;;  :method "Post.Publish"
                     :method "Post2.Publish"
                     :params {:options {:debug false}
                              :data [ruid]}}
                    ;; [::http-post-action-success]
                    [::http-post-action-success ruid]
                    [::http-post-action-failure])))


(re-frame/reg-event-db
 ::http-create-screen-success
[(events/api-msg-interceptor {:id :http-create-screen-success-api-msg-interceptor
                              :result-modifier-fn (fn [msg] (string/replace msg #"/screen/" "/screening/"))
                              :error-modifier-fn (fn [msg] (string/replace msg #"/screen/" "/screening/"))})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])

   (let [scopes (get-in data [:result :data :scopes])]
     (doseq [s scopes]
       (re-frame/dispatch [::http-get-screening-status s])))

  ;;  (-> db
  ;;      (assoc-in
  ;;       ;; [:posts :message]
  ;;       [:message]
  ;;       ;; (or (string/replace (get-in data [:result :message]) #"/screen/" "/screening/")
  ;;       ;;     (get-in data [:error :message]))
  ;;       (string/replace (or (get-in data [:result :message]) (get-in data [:error :message])) #"/screen/" "/screening/")))
   
   db))


(re-frame/reg-event-db
 ::http-create-screen-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;  (-> db
   ;;     ;;  (assoc-in [:posts :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::screen-create
 (fn [e [_ data]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Screen.Create"
                     :params {:options {:debug false}
                              :data data}}
                    [::http-create-screen-success]
                    [::http-create-screen-failure])))







(re-frame/reg-event-db
 ::http-get-header-success
 [(events/api-msg-interceptor
   {:id :http-get-header-success-api-msg-interceptor
    ;; ruid to link turned off per request in IRS-54
    ;; :result-modifier-fn (fn [msg] (linkify-header msg))
    :error-modifier-fn (fn [msg] (str "Header not found: " msg))})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])
 
   (if-let [result-data (get-in data [:result :data])]
     (-> db
         (assoc-in [:posts :header] result-data))
     db)))


(re-frame/reg-event-db
 ::http-get-header-failure
 [(events/api-msg-interceptor
   {:id :http-get-header-failure-api-msg-interceptor
    :debug-message-modifier-fn (fn [msg] (str "Header API failure: " msg))})]
 (fn [db]
   ;; this gets triggered on http fail
   ;;  not not being able to pull record, we still get a "success" response
   (re-frame/dispatch [::http-complete])
   db))


(re-frame/reg-event-fx
 ::http-get-header
 (fn [e [_ id]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Header.Get"
                     :params {:options {:debug false}
                              :data id}}
                    [::http-get-header-success]
                    [::http-get-header-failure])))


(defn get-header-flow [qp ruid]
  {:first-dispatch [::http-get-header ruid]
   :rules [{:when :seen?
            :events ::http-get-header-success
            :dispatch-fn (fn [[e result-data]]
                           (if (:error result-data)
                             [[::error-events/set-error {:title "Error: Header not found!"
                                                         :message (str "Invalid parameter(s): Header " ruid " NOT FOUND")}]]
                             [[::http-get-screening-status ruid {:prevent-http-complete true}]
                              [::http-get-post-list-batch qp]]))}
           {:when :seen-any-of?
            :events [::http-get-header-failure ::http-get-header-success]
            :halt? true}]})


(re-frame/reg-event-fx
 ::http-get-header-flow
 [(re-frame/inject-cofx :header-loaded) events/redo-interceptor]
 (fn [{:keys [db] :as cofx} [_ qp ruid]]
   (if (not (:header-loaded cofx))
     {:async-flow (get-header-flow qp ruid)}
     {:fx [[:dispatch [::http-get-post-list-batch qp]]]})))



;;  {
;;     "method": "Header.Render",
;;     "params": {
;;         "data": [
;;             "/acme.TLO"
;;         ],
;;         "options": {
;;             "debug": false
;;         }
;;     },
;;     "id": 0,
;;     "jsonrpc": "2.0"
;; }
;; {
;;     "message": "OK. Header /acme.TLO rendered."
;; }

(re-frame/reg-event-db
 ::http-render-header-success
 [(events/api-msg-interceptor {:id :http-render-header-success-api-msg-interceptor
                               :result-modifier-fn (fn [msg] (linkify-header msg))})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])

   ;;  (let [message (get-in data [:result :message])]
   ;;    (-> db
   ;;        ;;  (assoc-in [:posts :message] message)
   ;;        (assoc-in [:message] message)))
   db))


(re-frame/reg-event-db
 ::http-render-header-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;this will not work - this gets triggered on http fail - not not being able to pull record, we still get valid response
   ;;  (-> db
   ;;      ;;  (assoc-in [:posts :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::http-render-header
 (fn [e [_ id]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Header.Render"
                     :params {:options {:debug false}
                              :data [id]}}
                    [::http-render-header-success]
                    [::http-render-header-failure])))







(defn render-header-flow
  [ruid]
  {:first-dispatch [::http-render-header ruid]         ;; kicks things off
   :rules [;; a set of rules describing the required flow
           {:when :seen?
            :events ::http-render-header-success
            :dispatch [::http-get-header ruid]}
           {:when :seen-any-of?
            :events [::http-get-header-success ::http-render-header-failure]
            :halt? true}
          ;;  {:when :seen-any-of? :events [:fail-X :fail-Y :fail-Z] :dispatch [:app-failed-state] :halt? true}
           ]})


(re-frame/reg-event-fx                    ;; note the -fx
 ::http-render-header-flow                         ;; usage: (dispatch [:boot])  See step 3
 (fn [e [_ ruid]]
   {:async-flow (render-header-flow ruid)}))



    ;; public onDeleteImageClick(e) {
    ;;     e.preventDefault();
    ;;     if (this.entity.has_og_image) {
    ;;         if (confirm("Confirm Deleting OG Image!")) {
    ;;             this.store.dispatch( new entitiesActions.DeleteOgImageEffects({
    ;;                 ruid: this.entity.ruid
    ;;             }));
    ;;         }
    ;;     }
    ;; }

;; const jsonPayload = {
;;          "method": "Header.SetOgImage",
;;          "params": {
;;              "data": payload,
;;              "options": {
;;                  "debug": false
;;              }
;;          },
;;          "id": 0,
;;          "jsonrpc": "2.0"
;;      };
    ;;  const jsonPayload = {
    ;;      "method": "Header.DeleteOgImage",
    ;;      "params": {
    ;;          "data": payload,
    ;;          "options": {
    ;;              "debug": false
    ;;          }
    ;;      },
    ;;      "id": 0,
    ;;      "jsonrpc": "2.0"
    ;;  };





(re-frame/reg-event-db
 ::http-header-delete-og-image-success
 [(events/api-msg-interceptor {:id :http-header-delete-og-image-success-api-msg-interceptor
                               :result-modifier-fn (fn [msg] (linkify-header msg))})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])

   ;;  (let [message (get-in data [:result :message])]
   ;;    (-> db
   ;;       ;;  (assoc-in [:posts :message] message)
   ;;        (assoc-in [:message] message)))
   db))


(re-frame/reg-event-db
 ::http-header-delete-og-image-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;this will not work - this gets triggered on http fail - not not being able to pull record, we still get valid response
   ;;  (-> db
   ;;     ;;  (assoc-in [:posts :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::http-header-delete-og-image
 (fn [e [_ id]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Header.DeleteOgImage"
                     :params {:options {:debug false}
                              :data id}}
                    [::http-header-delete-og-image-success]
                    [::http-header-delete-og-image-failure])))



(defn header-delete-og-image-flow
  [ruid]
  {:first-dispatch [::http-header-delete-og-image ruid]         ;; kicks things off
   :rules [;; a set of rules describing the required flow
           {:when :seen?
            :events ::http-header-delete-og-image-success
            :dispatch [::http-get-header ruid]}
           {:when :seen-any-of?
            :events [::http-get-header-success ::http-render-header-failure]
            :halt? true}
          ;;  {:when :seen-any-of? :events [:fail-X :fail-Y :fail-Z] :dispatch [:app-failed-state] :halt? true}
           ]})


(re-frame/reg-event-fx                    ;; note the -fx
 ::http-header-delete-og-image-flow                         ;; usage: (dispatch [:boot])  See step 3
 (fn [e [_ ruid]]
   {:async-flow (header-delete-og-image-flow ruid)}))







(re-frame/reg-event-db
 ::http-thread-refresh-replies-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ id data]]
  ;;  (println "_" _)
  ;;  (println "::http-thread-refresh-replies-success data::" data)
  ;;  (println "ID:" id)
   (re-frame/dispatch [::http-complete])
   (let [n (get-in data [:result :data :n_replies])
         d (new js/Date (get-in data [:result :data :iso_last]))
         t (/ (- (.getTime d) (* (.getTimezoneOffset d) 60000)) 1000)]
     (-> db
         (assoc-in [:posts :fb-data :replies (str "@OP" id)] {:n n :t t})
        ;;  (assoc-in
        ;;   ;; [:posts :message]
        ;;   [:message]
        ;;   (or (get-in data [:result :message]) (get-in data [:error :message])))
         ))))


(re-frame/reg-event-db
 ::http-thread-refresh-replies-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;this will not work - this gets triggered on http fail - not not being able to pull record, we still get valid response
   ;;  (-> db
   ;;     ;;  (assoc-in [:posts :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::http-thread-refresh-replies
 (fn [e [_ id]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Thread.RefreshReplies"
                     :params {:options {:debug false}
                              :data id}}
                    [::http-thread-refresh-replies-success id]
                    [::http-thread-refresh-replies-failure])))



;; (re-frame/reg-event-db
;;  ::http-post-create-success
;;  (fn [db [_ data]]
;;    (re-frame/dispatch [::http-complete])

;;    (let [d (get-in data [:result :data])
;;          plus-iof (string/index-of (:id d) "+")
;;          prefix (subs (:id d) 1 plus-iof)
;;          suffix (subs (:id d) (+ plus-iof 1))
;;          route-str (routes/url-for :thread :id (str suffix "#" prefix))]
;;      (re-frame/dispatch [::events/route-to route-str])
;;      (cond
;;        (= (:level d) 1) (re-frame/dispatch [::events/reset-form "op-form"])
;;        (= (:level d) 2)
;;        (do
;;          (re-frame/dispatch [::http-get-thread {:board (:thread d) :level 2}])
;;          (re-frame/dispatch [::events/reset-form "reply-form"]))))
;;    (-> db
;;        (assoc-in [:posts :message] (or (get-in data [:result :message]) (get-in data [:error :message]))))))



;; TODO: there is an issue here on localhost, plus-iof line (api response probably changed)
;; here is the api response for reply creation:
;; {"jsonrpc": "2.0", "id": 0, "result": {"message": "OK. Post created: @Evrg+1ngY3RAW", "meta": {"publish_task": {"status": "ENQUEUED", "eta": 1691015079.083644, "task_id": "79022eb1-089f-457e-b4f3-746b70c5b6b3"}}, "data": {"ruid": "@Evrg+1ngY3RAW", "re": "@OP+1ngY3RAW", "ref": "@Evrg+1ngY3RAW", "thread_path": "/t/1ngY3RAW"}}}
;; here is OP creation:
;; {"jsonrpc": "2.0", "id": 0, "result": {"message": "OK. Post created: @OP+1nUXRkcv", "meta": {"publish_task": {"status": "ENQUEUED", "eta": 1691017167.330806, "task_id": "90861443-d3fe-4667-8a6e-10dd09407a53"}}, "data": {"ruid": "@OP+1nUXRkcv", "re": "/aaalphabet.TLO", "ref": "@OP+1nUXRkcv", "thread_path": "/t/1nUXRkcv"}}}
;; Also, TODO: when doing redirect anchor scrolling on new post doesn't work very well
(re-frame/reg-event-db
 ::http-post-create-success
 [(events/api-msg-interceptor {:id :http-post-create-success-api-msg-interceptor
                               :result-modifier-fn (fn [msg] (ruid-to-ahref msg))})]
 (fn [db [_ dm data]]
   (re-frame/dispatch [::http-complete])

   (when-let [ruid (get-in data [:result :data :ruid])]
     (if-let [on-success-cb (:on-success dm)]
       (on-success-cb)
       (let [plus-iof (string/index-of ruid "+")
             prefix (subs ruid 1 plus-iof)
             suffix (subs ruid (+ plus-iof 1))
             route-str (routes/url-for :thread :id (str suffix "#" prefix))]
         (re-frame/dispatch [::events/route-to route-str])
         (cond
           (= prefix "OP") (re-frame/dispatch [::events/reset-form "op-form"])
           (not= prefix "OP")
           (do
             (re-frame/dispatch [::http-get-thread {:board (str "+" suffix) :level 2}])
             (re-frame/dispatch [::events/reset-form "reply-form"]))))))

   (when-let [error-msg (get-in data [:error :message])]
     (when-let [on-error-cb (:on-error dm)]
       (on-error-cb error-msg))) 
   db))


(re-frame/reg-event-db
 ::http-post-create-failure
 [(events/api-msg-interceptor
   {:id :http-post-create-failure-api-msg-interceptor
    :debug-message-modifier-fn (fn [msg] (str "Post Create API failure: " msg))})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   db))


(re-frame/reg-event-fx
 ::post-create
 (fn [e [_ data dm]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                    ;;  :method "Post.Create"
                     :method "Post2a.Create"
                     :params {:options {:debug false}
                              :data (merge {
                                            ;; :hidden false
                                            :isHidden false
                                            :countdown 0}
                                           data)}}
                    [::http-post-create-success dm]
                    [::http-post-create-failure])))




(re-frame/reg-event-db
 ::set-posts-filters-from-qp-data
 (fn [db [_ data]]
   (assoc-in db [:posts :filter-data] data)))


;; (re-frame/reg-event-db
;;  ::set-posts-filters-from-qp
;;  (fn [db [_ qp]]

;;    (let [qp-labels {:lang "Languages"
;;                     :user "User"
;;                     :mime "MIME"
;;                     :ua "UA"
;;                     :cc "Country"
;;                     :ip "IP"
;;                     :cookie "Cookie"
;;                     :bfp "BFP"
;;                     :dfp "DFP"
;;                     :thread "Thread"
;;                     :board "Board"}
;;          qp-labels-filtered (filterv #(% qp-labels) (keys qp))]

;;      (go
;;        (when-let [filter-data
;;                   (loop [qp-lf qp-labels-filtered
;;                          results []]
;;                     (if (some? (first qp-lf))
;;                       (let [f (first qp-lf)
;;                             r (conj results {:param f :label (f qp-labels) :value (<! (hench/eid-to-raid (f qp)))})]
;;                         (recur (rest qp-lf) r))
;;                       results))]
;;          (re-frame/dispatch [::set-filter-data filter-data]))))))




(defn prefix-query-param [param value]
  (cond  (= param :ws)
         (str "." value)
         (= param :cc)
         (str ":" value)
         (= param :ip)
         (str "^" value)
         (= param :thread)
         (str "+" value)
         :else
         value))

(re-frame/reg-event-fx
 ::set-posts-filters-from-qp
;;  (fn [e [_ qp]]
(fn [{:keys [db]} [_ qp]]
;; this is for posts section filters only, has nothing to do with eid, ip, cc sections
   (let [qp-labels {:ws "Website"
                    :geo "Geo"
                    :lang "Languages"
                    :user "User"
                    :mime "MIME"
                    :ua "UA"
                    :cc "Country"
                    :ip "IP"
                    :cookie "Cookie"
                    :bfp "BFP"
                    :dfp "DFP"
                    :thread "Thread"
                    :board "Board"}
         qp-raidizable #{:geo
                         :lang
                         :mime
                         :ua
                         :cookie
                         :bfp
                         :dfp}
         qp-labels-filtered (filterv #(% qp-labels) (keys qp))
         raid-len (:raid-len db)]

     (go
       (when-let [filter-data
                  (loop [qp-lf qp-labels-filtered
                         results []]
                    (if (some? (first qp-lf))
                      (let [f (first qp-lf)
                            r (conj results {:param f
                                             :label (f qp-labels)
                                             :value (if (and (not-empty (f qp)) (contains? qp-raidizable f))
                                                      ;; (<! (hench/eid-to-raid (f qp)))
                                                      (hench/eid-len-raid (f qp) raid-len)
                                                      (prefix-query-param f (f qp)))})]
                        (recur (rest qp-lf) r))
                      results))]
         (re-frame/dispatch [::set-posts-filters-from-qp-data filter-data]))))
         {}))


(re-frame/reg-event-fx


 ::http-get-post-list-batch
  ;; (fn [cofx e [_ query-params]]
 [(re-frame/inject-cofx :pq)]
 (fn [{:keys [db] :as cofx} [e query-params predata]]
    ;; TODO: in case of excerpt yes - interval is stopped but not continued
    ;; needs to be moved inside :pq-load-posts-ok true?
  ;; TODO: revisit interval end start stuff, because of lazy loading things changed
    ;; (interval-end)
    ;; perhaps this should happen elsewhere, currently Post.List runs before db gets updated with defaults
   (re-frame/dispatch [::set-posts-defaults-from-qp query-params])

    ;; flag and staff params need to be added to post-rpc but api currently doesn't support it

    ;; for layout: perhaps some kind of filter here which compares state in db with query params. Trigger Post.List load only if crucial params changed not the one like "layout". Also interval need to be taken into consideration, not sure if it is needed in table view, but again maybe triggering it once user switched back to list is unnecessary complication
    ;; another option is maybe some kind of skip load atom set to true by table/list buttons, loaded in post.list effect as cofx :skip-load and reset to false


    ;; (println (get-in e [:db :posts]))
    ;; (println "select-keys:::" (select-keys (get-in e [:db :posts]) (into [] (keys query-params))))

    ;; save prev-query-parameters and if same with new ones (excluding layout) do not load - possible problem with scroll loading although we maybe could use bookmarks with params
    ;; maybe in interceptor

    ;; (.log js/console @prev-query-params)
    ;; (.log js/console (dissoc query-params :layout))


;; TODO: there is a problem when comparing :limit 50 and :limit "50" (int vs string)
    ;; next time around that problem dissapears but first time is present
    ;; (when (not= (dissoc query-params :layout) @prev-query-params)

      ;; (reset! prev-query-params (dissoc query-params :layout))

   (when (true? (:pq-load-posts-ok cofx))

     (interval-end)

     (events/post-rpc {:jsonrpc "2.0"
                       :id 0
                      ;;  :method "Post.ListBatch"
                       :method "Post2a.ListBatch"
                       :params {:options {:debug false}
                                :data (merge {:include_screening_status true
                                              :scopes (get-scopes-from-query-params query-params)
                                      ;;  TODO: look into returning level, it goes in scopes (sometimes) so not sure if needed
                                      ;;  :level (int (or (:level query-params) (get-in db [:posts :level])))
                                      ;;  :level nil
                                              :status (or (:status query-params) (get-in db [:posts :status]))
                                              :sort_by (or (:sort query-params) (get-in db [:posts :sort]))
                                      ;;  :after ""
                                      ;;  :before ""
                                              :bookmark (:bm query-params)
                                      ;; had to eliminate pulling page from db because it pulls 11 (::set-posts-defaults doesn't get executed in time)
                                      ;; :page (int (or (:page query-params) (get-in e [:db :posts :page])))
                                      ;;  :page (int (or (:page query-params) 1))
                                      ;;  :limit (int (or (:limit query-params) (get-in db [:posts :limit])))
                                      ;; :limit (int (or (:n query-params) (get-in e [:db :posts :limit])))

                                              :batch_limit (if (and (> (int (:limit query-params)) 0) (< (int (:limit query-params)) 50)) (int (:limit query-params)) 50)
                                              :page_limit (int (or (:limit query-params) (get-in db [:posts :limit])))
                                              :ruids_only false}
                                             (when-let [staff (cond (= (:staff query-params) "yes") "yes"
                                                                    (= (:staff query-params) "no") "no"
                                                                    :else nil)]
                                               {:staff staff})
                                             (when-let [flag (:flag query-params)]
                                               {:flag flag}))

                            ;;    (merge {:bookmark ""
                            ;;            :limit (if-not (zero? (int (:n query-params))) (int (:n query-params)) 50)
                            ;;            :page (if-not (zero? (int (:page query-params))) (int (:page query-params)) 1)}
                            ;;           (when-let [order (:order query-params)]
                            ;;             {:order order})
                            ;;           (when-let [scope (:scope query-params)]
                            ;;             {:scope scope}))
                                }}
                      [::http-get-post-list-batch-success query-params predata]
                      [::http-get-post-list-failure]
                      [::events/track-request "Post.ListBatch"]))))


(re-frame/reg-event-fx
 ::http-get-post-list-batch-debounced
 [events/redo-interceptor]
 (fn [e [_ query-params]]
   {::events/dispatch-debounce ["Post.ListBatch"
                                [::http-get-post-list-batch query-params]
                                1000]}))





;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

;; Scope.GetLogTimespan ti vrati first_seen i last_seen

;; Scope.GetEidMetadata ti vrati dekriptovani ruid

;; Za screening status imas vec postojecu metodu ScreeningStatus.Get koja prima ili jedan ruid (ruid=...) ili listu (ruids= [...])


(re-frame/reg-event-db
 ::http-get-scope-eid-metadata-success
 [(events/api-msg-interceptor {:mute-keys #{:result}})]
 (fn [db [_ eid data]]
   (re-frame/dispatch [::http-complete])

   (let [result-data (get-in data [:result :data])]
     (-> db
         (assoc-in [:posts :eid :metadata eid] result-data)))))


(re-frame/reg-event-db
 ::http-get-scope-eid-metadata-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;this will not work - this gets triggered on http fail - not not being able to pull record, we still get valid response
   ;;  (-> db
   ;;     ;;  (assoc-in [:posts :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::http-get-scope-eid-metadata
 (fn [e [_ eid]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Scope.GetEidMetadata"
                     :params {:options {:debug false}
                              :data eid}}
                    [::http-get-scope-eid-metadata-success eid]
                    [::http-get-scope-eid-metadata-failure])))




;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;



(re-frame/reg-event-db
 ::http-get-log-timespan-success
 [(events/api-msg-interceptor {:mute-keys #{:result}})]
 (fn [db [_ data]]
   (re-frame/dispatch [::http-complete])

   (let [result-data (get-in data [:result :data])]
     (-> db
         (assoc-in [:posts :eid :logs] result-data)))))


(re-frame/reg-event-db
 ::http-get-log-timespan-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;this will not work - this gets triggered on http fail - not not being able to pull record, we still get valid response
   ;;  (-> db
   ;;     ;;  (assoc-in [:posts :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::http-get-log-timespan
 (fn [e [_ eid]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Scope.GetLogTimespan"
                     :params {:options {:debug false}
                              :data eid}}
                    [::http-get-log-timespan-success]
                    [::http-get-log-timespan-failure])))



;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

;; (re-frame/reg-event-db
;;  ::http-get-screening-status-success
;;  (fn [db [_ data]]
;;    (re-frame/dispatch [::http-complete])

;;    (println data)
;;    (let [result-data (get-in data [:result :data])]
;;      (-> db
;;          (assoc-in [:posts :eid :screening] result-data)))))


(re-frame/reg-event-db
 ::http-get-screening-status-success
 [(events/api-msg-interceptor {:mute-keys #{:result}})]
 (fn [db [_ options data]]
   (when-not (:prevent-http-complete options)
     (re-frame/dispatch [::http-complete]))
   (let [result-data (get-in data [:result :data])
         ruid (:ruid result-data)]
     (-> db
         (assoc-in [:posts :screening-status (keyword ruid)] result-data)))))


(re-frame/reg-event-db
 ::http-get-screening-status-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   ;;  (re-frame/dispatch [::http-complete])
   ;;this will not work - this gets triggered on http fail - not not being able to pull record, we still get valid response
   ;;  (-> db
   ;;     ;;  (assoc-in [:posts :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


;; (re-frame/reg-event-fx
;;  ::http-get-screening-status
;;  (fn [e [_ eid]]
;;    (events/post-rpc {:jsonrpc "2.0"
;;                      :id 0
;;                      :method "ScreeningStatus.Get"
;;                      :params {:options {:debug false}
;;                               :data eid}}
;;                     [::http-get-screening-status-success]
;;                     [::http-get-screening-status-failure])))

(re-frame/reg-event-fx
 ::http-get-screening-status
 (fn [e [_ scopes options]]
   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "ScreeningStatus.Get"
                     :params {:options {:debug false}
                              :data scopes}}
                    [::http-get-screening-status-success options]
                    [::http-get-screening-status-failure])))






;; TODO: search result data needs to be tied with eid/raid
(re-frame/reg-event-db
 ::http-post-search-success
 [(events/api-msg-interceptor {})]
 (fn [db [_ ws data]]
   (re-frame/dispatch [::set-post-list-batch-datetime (.now js/Date)])
   (re-frame/dispatch [::http-complete])

   (let [result-data (add-ws-to-refs (get-in data [:result :data]) ws)
         result-meta (or (get-in data [:result :meta]) (get-in data [:error]))]

    ;;  TODO: problem with this is data result data does not contain "eids" (:author :eid) so there is nothing to raidize

     (when (not-empty result-data)
       (interval-start)
       (re-frame/dispatch [::set-post-fb-data result-data])
      ;;  (re-frame/dispatch [::set-post-fb-data-eid-raid result-data])
       (re-frame/dispatch [::admin-all-moderation-logs result-data])
      ;;  (take! (raidize-result-data result-data)
      ;;         (fn [raidized-result-data]
      ;;           ;; (re-frame/dispatch [::set-fb-data :raid (:raid raidized-result-data)])
      ;;           (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-result-data [:result])])
      ;;           ))
       )

     (-> db
         (assoc-in [:posts :data] result-data)
        ;;  (assoc-in [:posts :meta] result-meta)
         (assoc-in [:posts :meta] (dissoc result-meta :screening_status))
         (assoc-in [:posts :screening-status] (get-in result-meta [:screening_status]))
        ;;  (assoc-in [:message] (or (get-in data [:result :message]) (get-in data [:error :message])))
         ))))


(re-frame/reg-event-db
 ::http-post-search-failure
 [(events/api-msg-interceptor {})]
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;this will not work - this gets triggered on http fail - not not being able to pull record, we still get valid response
   ;;  (-> db
   ;;     ;;  (assoc-in [:posts :message] "API connection failure!")
   ;;      (assoc-in [:message] "API connection failure!"))
   db))


(re-frame/reg-event-fx
 ::http-post-search
 (fn [e [_ ws index limit order page q maxcount]]

   (re-frame/dispatch [::set-posts-meta nil])

   (events/post-rpc {:jsonrpc "2.0"
                     :id 0
                     :method "Post2a.Search"
                     :params {:options {:debug false}
                              :data (merge {:include_screening_status true
                                            :index index
                                            :limit (int limit)
                                            :order order
                                            :page (int page)
                                            :ws ws
                                            :q q
                                            :ruids_only false}
                                           (when (> maxcount 0)
                                             {:number_found_accuracy maxcount}))}}
                    [::http-post-search-success ws]
                    [::http-post-search-failure])))









 (re-frame/reg-event-fx
 ::http-get-latest-post-list-success
  [(events/api-msg-interceptor {})]
 (fn [{:keys [db]} [_ query-params data]]

   (let [
        ;;  sdd (get-in db [:posts :data])
        ;;  bmd (get-in db [:posts :batch-meta])
         md (get-in data [:result :meta])
          ;; dd (get-in data [:result :data])
         dd (add-ws-to-refs (get-in data [:result :data]) (:ws query-params))
          ;; pd (if (empty? predata) predata (if (vector? predata) predata (conj [] predata)))
          ;; pd (if (empty? predata) dd (if (vector? predata) predata (conj [] predata)))
        ;;  pd (if (empty? predata) predata (if (vector? predata) predata (conj [] predata)))
        ;;  ad (if (empty? pd) dd (reduce conj pd dd))
         ]

      ;; (println "dd:" dd)

      ;; (println "PD::" pd)
      ;; (println "ad::" ad)


    ;;  TODO: think it would be best to move eager Post calls here (no sense in passing to meta)

    ;;  (re-frame/dispatch [::set-post-list-meta query-params md])
      ;; (cond (= method "Post.List")
      ;;       (re-frame/dispatch [::set-post-list-meta md])
      ;;       (= method "Post.ListBatch")
      ;;       (re-frame/dispatch [::set-post-list-batch-meta md]))

     (re-frame/dispatch [::set-post-list-meta md])
    ;;  (re-frame/dispatch [::set-post-list-data ad])
     (re-frame/dispatch [::set-post-list-data dd])
     (re-frame/dispatch [::set-post-list-batch-datetime (.now js/Date)])
     (re-frame/dispatch [::http-complete])














     (when (not-empty dd)
        ;; (interval-start)
       (re-frame/dispatch [::set-post-fb-data dd])
      ;;  (re-frame/dispatch [::set-post-fb-data-eid-raid dd])
      ;;  (take! (raidize-result-data dd)
      ;;         (fn [raidized-result-data]
      ;;           (println "raidized-result-data::" raidized-result-data)
      ;;           ;; (re-frame/dispatch [::set-fb-data :raid (:raid raidized-result-data)])
      ;;           (re-frame/dispatch [::set-fb-data :eid-raid (get-in raidized-result-data [:result])])
      ;;           ))

      ;;  (when (and (true? (:has_more md))
      ;;             (not= (:next_bookmark md) (:next_page_bookmark bmd))
      ;;             (= @interval-id curr-interval-id))
      ;;    (re-frame/dispatch [::http-get-post-list (merge query-params {:nbm (get-in md [:next_bookmark])}) ad curr-interval-id]))
       )
     )
   {}))



 (re-frame/reg-event-db
  ::http-get-latest-post-list-failure
  [(events/api-msg-interceptor {})]
  (fn [db]
    (re-frame/dispatch [::http-complete])
    ;;  (-> db
    ;;       ;; (assoc-in [:posts :message] "API connection failure!")
    ;;      (assoc-in [:message] "API connection failure!"))
    db))


(re-frame/reg-event-fx
 ::http-get-latest-post-list
  ;; (fn [cofx e [_ query-params]]
 [(re-frame/inject-cofx :pq) events/redo-interceptor]
 (fn [{:keys [db] :as cofx} [e query-params]]

   (re-frame/dispatch [::set-posts-defaults-from-qp query-params])

  ;;  (println "COFX FROM LATEST::" cofx)

   (when (true? (:pq-load-posts-ok cofx))

     (interval-end)

     (events/post-rpc {:jsonrpc "2.0"
                       :id 0
                       :method "Post.List"
                       :params {:options {:debug false}
                                :data (merge {:include_screening_status true
                                              :scopes (get-scopes-from-query-params query-params)
                                             ;; :level (int (or (:level query-params) (get-in db [:posts :level])))
                                             ;; :level nil
                                              :level 1
                                              :status "P"
                                              :sort_by "submitted"
                                             ;; :after ""
                                             ;; :before ""
                                                 ;; :bookmark (:nbm query-params)
                                           ;; had to eliminate pulling page from db because it pulls 11 (::set-posts-defaults doesn't get executed in time)
                                           ;; :page (int (or (:page query-params) (get-in e [:db :posts :page])))
                                             ;; :page (int (or (:page query-params) 1))
                                             ;; :limit (int (or (:limit query-params) (get-in db [:posts :limit])))
                                           ;; :limit (int (or (:n query-params) (get-in e [:db :posts :limit])))

                                              :limit 75
                                              :ruids_only false}
                                             (when-let [staff (cond (= (:staff query-params) "yes") "yes"
                                                                    (= (:staff query-params) "no") "no"
                                                                    :else nil)]
                                               {:staff staff})
                                             (when-let [flag (:flag query-params)]
                                               {:flag flag}))

                                 ;;    (merge {:bookmark ""
                                 ;;            :limit (if-not (zero? (int (:n query-params))) (int (:n query-params)) 50)
                                 ;;            :page (if-not (zero? (int (:page query-params))) (int (:page query-params)) 1)}
                                 ;;           (when-let [order (:order query-params)]
                                 ;;             {:order order})
                                 ;;           (when-let [scope (:scope query-params)]
                                 ;;             {:scope scope}))
                                }}
                      [::http-get-latest-post-list-success query-params]
                      [::http-get-latest-post-list-failure]
                      [::events/track-request "Post.List"])

     )

   ))


(re-frame/reg-event-fx
 ::http-get-latest-post-list-debounced
 (fn [e [_ query-params]]
   {::events/dispatch-debounce ["Post.ListLatest"
                                [::http-get-latest-post-list query-params]
                                1000]}))


(re-frame/reg-event-db
 ::set-admin-moderation-logs
 (fn [db [_ value]]
   (assoc-in db [:posts :moderation-log-data] value)))


(re-frame/reg-event-db
 ::set-admin-all-moderation-logs
 (fn [db [_ id value]]
   (assoc-in db [:posts :all-moderation-log-data (keyword id)] value)))

;; TODO: if the original set-admin-all-moderation-logs event is no longer in use, delete and rename the one below
(re-frame/reg-event-db
 ::set-admin-all-moderation-logs-2
 (fn [db [_ value]]
   (assoc-in db [:posts :all-moderation-log-data]
             (merge (get-in db [:posts :all-moderation-log-data]) value))))

(re-frame/reg-event-db
 ::update-post-props
 (fn [db [_ id updates]]
   (let [data (get-in db [:posts :data])
         new-data (mapv (fn [item]
                         (if (= id (:id item))
                           (merge item updates)
                           item)) data)]
     (assoc-in db [:posts :data] new-data))))


;; https://clojureverse.org/t/how-to-replace-cljs-http-client-get-with-js-fetch/9490
(defn fetch-post [ruid]
  (let [jwt @globals/jwt]
    (js/fetch js/apolloURL
              (clj->js {:method "POST"
                        :headers {:authorization (str "Bearer " jwt)
                                  :content-type "application/json"}
                        :body (js/JSON.stringify (clj->js {:jsonrpc "2.0"
                                                           :id 0
                                                                                      ;; :method "Post.Get"
                                                           :method "Post2a.Get"
                                                           :params {:options {:debug false}
                                                                    :data {:ruid ruid
                                                                           :include_screening_status false}}}))}))))


(defn set-post-ref-preview-data [paruid ruid preview]
  (re-frame/dispatch [::set-post-ref-preview-data paruid ruid (merge preview {:dt (.now js/Date)})]))


(defn fetch-cache-set-post-ref-preview-data [paruid ruid]
  (re-frame/dispatch [::http-loading true])
  (go
    (let [res (<p! (fetch-post ruid))]
      (when (= 200 (.. res -status))
        (let [body (-> (<p! (.. res (json)))
                       (js->clj :keywordize-keys true))]
          (idb/add-ref-preview ruid (clj->js (get-in body [:result :data])))
          (re-frame/dispatch [::set-post-ref-preview-data paruid ruid (merge (get-in body [:result :data]) {:dt (.now js/Date)})])
          (re-frame/dispatch [::http-loading false]))))))


(defn- get-ruid-from-a-target-href [target]
  (-> target
      (.getAttribute "href")
      (.split "/")
      (last)
      (.split "#")
      (.reverse)
      (.join "+")
      (->> (str "@"))))

(defn- get-ruid-from-a-target-parent-article [target]
  (when-let [article (.closest target "article")]
    (-> article
        (.getAttribute "ruid")
        (->> (str "@")))))

(defn load-post-ref-from-a-pref-mouseover-event [target]
  (when-let [ruid (get-ruid-from-a-target-href target)]
    (when-let [paruid (get-ruid-from-a-target-parent-article target)]
      (go
        (if-let [preview (-> (<p! (idb/get-ref-preview ruid))
                             (js->clj :keywordize-keys true))]
          (set-post-ref-preview-data paruid ruid preview)
          (fetch-cache-set-post-ref-preview-data paruid ruid))))))